export const ProfileSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.6515 20.4054C20.2044 20.2902 20.5336 19.7117 20.2589 19.2183C19.6533 18.1307 18.6993 17.1749 17.4789 16.4465C15.9071 15.5085 13.9812 15 12 15C10.0188 15 8.09295 15.5085 6.52115 16.4465C5.30072 17.1749 4.34669 18.1307 3.74111 19.2183C3.46641 19.7117 3.79565 20.2902 4.34847 20.4054C9.39527 21.4572 14.6047 21.4572 19.6515 20.4054Z"
      fill="#1890FF"
    />
    <circle cx="12" cy="8" r="5" fill="#1890FF" />
  </svg>
);

export const LogoutSvg = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.33048 0.0214844C11.7097 0.0214844 13.6516 1.89542 13.7607 4.24772L13.7655 4.45648V5.38948C13.7655 5.8037 13.4297 6.13948 13.0155 6.13948C12.6358 6.13948 12.322 5.85733 12.2723 5.49125L12.2655 5.38948V4.45648C12.2655 2.89358 11.0435 1.61575 9.50292 1.52647L9.33048 1.52148H4.45548C2.89343 1.52148 1.61574 2.74362 1.52647 4.28406L1.52148 4.45648V15.5865C1.52148 17.1493 2.74339 18.4272 4.28314 18.5165L4.45548 18.5215H9.34048C10.8978 18.5215 12.1715 17.3039 12.2605 15.7693L12.2655 15.5975V14.6545C12.2655 14.2403 12.6013 13.9045 13.0155 13.9045C13.3952 13.9045 13.709 14.1866 13.7586 14.5527L13.7655 14.6545V15.5975C13.7655 17.9687 11.8987 19.9046 9.55484 20.0164L9.34048 20.0215H4.45548C2.07704 20.0215 0.135325 18.1474 0.0263116 15.7952L0.0214844 15.5865V4.45648C0.0214844 2.07743 1.89524 0.135347 4.24679 0.0263125L4.45548 0.0214844H9.33048ZM20.3277 9.47968C20.4702 9.6162 20.559 9.80843 20.559 10.0214C20.559 10.2365 20.4684 10.4304 20.3234 10.5672L17.4099 13.4687C17.1164 13.761 16.6416 13.76 16.3493 13.4665C16.0835 13.1997 16.0602 12.783 16.2787 12.4898L16.3514 12.4059L17.9915 10.7714H7.76798C7.35377 10.7714 7.01798 10.4356 7.01798 10.0214C7.01798 9.64169 7.30014 9.32789 7.66621 9.27823L7.76798 9.27138H17.9932L16.3515 7.63779C16.0847 7.37212 16.0595 6.95551 16.2767 6.66142L16.3492 6.57714C16.6148 6.31028 17.0315 6.28514 17.3256 6.50234L17.4098 6.57478L20.3277 9.47968Z"
      fill="#ff4d4f"
    />
  </svg>
);

export const BottomArrowSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 8.5L12 15.5L5 8.5"
      stroke="#200E32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LeftArrowSVG = () => (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.646446 7.35355C0.451184 7.15829 0.451184 6.84171 0.646446 6.64645L6.64645 0.646446C6.84171 0.451184 7.15829 0.451184 7.35355 0.646446C7.54882 0.841709 7.54882 1.15829 7.35355 1.35355L1.70711 7L7.35355 12.6464C7.54882 12.8417 7.54882 13.1583 7.35355 13.3536C7.15829 13.5488 6.84171 13.5488 6.64645 13.3536L0.646446 7.35355Z"
      fill="black"
    />
  </svg>
);

export const InstagramSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.465 1.066C8.638 1.012 9.012 1 12 1C14.988 1 15.362 1.013 16.534 1.066C17.706 1.119 18.506 1.306 19.206 1.577C19.939 1.854 20.604 2.287 21.154 2.847C21.714 3.396 22.146 4.06 22.422 4.794C22.694 5.494 22.88 6.294 22.934 7.464C22.988 8.639 23 9.013 23 12C23 14.988 22.987 15.362 22.934 16.535C22.881 17.705 22.694 18.505 22.422 19.205C22.146 19.9391 21.7133 20.6042 21.154 21.154C20.604 21.714 19.939 22.146 19.206 22.422C18.506 22.694 17.706 22.88 16.536 22.934C15.362 22.988 14.988 23 12 23C9.012 23 8.638 22.987 7.465 22.934C6.295 22.881 5.495 22.694 4.795 22.422C4.06092 22.146 3.39582 21.7133 2.846 21.154C2.28638 20.6047 1.85331 19.9399 1.577 19.206C1.306 18.506 1.12 17.706 1.066 16.536C1.012 15.361 1 14.987 1 12C1 9.012 1.013 8.638 1.066 7.466C1.119 6.294 1.306 5.494 1.577 4.794C1.85372 4.06008 2.28712 3.39531 2.847 2.846C3.39604 2.2865 4.06047 1.85344 4.794 1.577C5.494 1.306 6.294 1.12 7.464 1.066H7.465ZM16.445 3.046C15.285 2.993 14.937 2.982 12 2.982C9.063 2.982 8.715 2.993 7.555 3.046C6.482 3.095 5.9 3.274 5.512 3.425C4.999 3.625 4.632 3.862 4.247 4.247C3.88205 4.60205 3.60118 5.03428 3.425 5.512C3.274 5.9 3.095 6.482 3.046 7.555C2.993 8.715 2.982 9.063 2.982 12C2.982 14.937 2.993 15.285 3.046 16.445C3.095 17.518 3.274 18.1 3.425 18.488C3.601 18.965 3.882 19.398 4.247 19.753C4.602 20.118 5.035 20.399 5.512 20.575C5.9 20.726 6.482 20.905 7.555 20.954C8.715 21.007 9.062 21.018 12 21.018C14.938 21.018 15.285 21.007 16.445 20.954C17.518 20.905 18.1 20.726 18.488 20.575C19.001 20.375 19.368 20.138 19.753 19.753C20.118 19.398 20.399 18.965 20.575 18.488C20.726 18.1 20.905 17.518 20.954 16.445C21.007 15.285 21.018 14.937 21.018 12C21.018 9.063 21.007 8.715 20.954 7.555C20.905 6.482 20.726 5.9 20.575 5.512C20.375 4.999 20.138 4.632 19.753 4.247C19.3979 3.88207 18.9657 3.60121 18.488 3.425C18.1 3.274 17.518 3.095 16.445 3.046ZM10.595 15.391C11.3797 15.7176 12.2534 15.7617 13.0669 15.5157C13.8805 15.2697 14.5834 14.7489 15.0556 14.0422C15.5278 13.3356 15.7401 12.4869 15.656 11.6411C15.572 10.7953 15.197 10.005 14.595 9.405C14.2112 9.02148 13.7472 8.72781 13.2363 8.54515C12.7255 8.36248 12.1804 8.29536 11.6405 8.34862C11.1006 8.40187 10.5792 8.57418 10.1138 8.85313C9.64845 9.13208 9.25074 9.51074 8.9493 9.96185C8.64786 10.413 8.45019 10.9253 8.37052 11.462C8.29084 11.9986 8.33115 12.5463 8.48854 13.0655C8.64593 13.5847 8.91648 14.0626 9.28072 14.4647C9.64496 14.8668 10.0938 15.1832 10.595 15.391ZM8.002 8.002C8.52702 7.47697 9.15032 7.0605 9.8363 6.77636C10.5223 6.49222 11.2575 6.34597 12 6.34597C12.7425 6.34597 13.4777 6.49222 14.1637 6.77636C14.8497 7.0605 15.473 7.47697 15.998 8.002C16.523 8.52702 16.9395 9.15032 17.2236 9.8363C17.5078 10.5223 17.654 11.2575 17.654 12C17.654 12.7425 17.5078 13.4777 17.2236 14.1637C16.9395 14.8497 16.523 15.473 15.998 15.998C14.9377 17.0583 13.4995 17.654 12 17.654C10.5005 17.654 9.06234 17.0583 8.002 15.998C6.94166 14.9377 6.34597 13.4995 6.34597 12C6.34597 10.5005 6.94166 9.06234 8.002 8.002ZM18.908 7.188C19.0381 7.06527 19.1423 6.91768 19.2143 6.75397C19.2863 6.59027 19.3248 6.41377 19.3274 6.23493C19.33 6.05609 19.2967 5.87855 19.2295 5.71281C19.1622 5.54707 19.0624 5.39651 18.936 5.27004C18.8095 5.14357 18.6589 5.04376 18.4932 4.97652C18.3275 4.90928 18.1499 4.87598 17.9711 4.87858C17.7922 4.88119 17.6157 4.91965 17.452 4.9917C17.2883 5.06374 17.1407 5.1679 17.018 5.298C16.7793 5.55103 16.6486 5.88712 16.6537 6.23493C16.6588 6.58274 16.7992 6.91488 17.0452 7.16084C17.2911 7.40681 17.6233 7.54723 17.9711 7.5523C18.3189 7.55737 18.655 7.42669 18.908 7.188Z"
      fill="white"
    />
  </svg>
);

export const TelegramSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.5014 5.08405L3.34315 11.3039C2.85065 11.4736 2.90537 12.2086 3.39788 12.3783L7.22847 13.6223L8.76071 18.5982C8.87015 18.994 9.36266 19.1071 9.63627 18.8243L11.8799 16.6757L16.1483 19.8987C16.4766 20.1249 16.9144 19.9552 17.0238 19.5594L19.9789 6.44112C20.143 5.47986 19.3222 4.74478 18.5014 5.08405ZM9.63627 14.5835L9.14377 17.5238L8.04931 13.4526L18.7202 6.21494L9.63627 14.5835Z"
      fill="white"
    />
  </svg>
);

export const FacebookSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.397 20.9972V12.8012H16.162L16.573 9.59217H13.397V7.54817C13.397 6.62217 13.655 5.98817 14.984 5.98817H16.668V3.12717C15.8487 3.03936 15.0251 2.99696 14.201 3.00017C11.757 3.00017 10.079 4.49217 10.079 7.23117V9.58617H7.33203V12.7952H10.085V20.9972H13.397Z"
      fill="white"
    />
  </svg>
);

export const PhoneSVG = ({ color }: { color?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.231 15.2617L16.691 14.9717C16.081 14.9017 15.481 15.1117 15.051 15.5417L13.211 17.3817C10.381 15.9417 8.06102 13.6317 6.62102 10.7917L8.47102 8.94172C8.90102 8.51172 9.11102 7.91172 9.04102 7.30172L8.75102 4.78172C8.63102 3.77172 7.78102 3.01172 6.76102 3.01172H5.03102C3.90102 3.01172 2.96102 3.95172 3.03102 5.08172C3.56102 13.6217 10.391 20.4417 18.921 20.9717C20.051 21.0417 20.991 20.1017 20.991 18.9717V17.2417C21.001 16.2317 20.241 15.3817 19.231 15.2617Z"
      fill={color ? color : "white"}
    />
  </svg>
);

export const MailSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM19.6 8.25L13.06 12.34C12.41 12.75 11.59 12.75 10.94 12.34L4.4 8.25C4.15 8.09 4 7.82 4 7.53C4 6.86 4.73 6.46 5.3 6.81L12 11L18.7 6.81C19.27 6.46 20 6.86 20 7.53C20 7.82 19.85 8.09 19.6 8.25Z"
      fill="white"
    />
  </svg>
);

export const LocationSVG = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9497 13.955C17.6834 11.2201 17.6834 6.78601 14.9497 4.05115C12.2161 1.31628 7.78392 1.31628 5.05025 4.05115C2.31658 6.78601 2.31658 11.2201 5.05025 13.955L6.57128 15.4538L8.61408 17.4389L8.74691 17.5567C9.52168 18.1847 10.6562 18.1455 11.3861 17.4391L13.8223 15.0691L14.9497 13.955ZM10 12C8.34315 12 7 10.6569 7 9C7 7.34315 8.34315 6 10 6C11.6569 6 13 7.34315 13 9C13 10.6569 11.6569 12 10 12Z"
      fill="#8C8C8C"
    />
  </svg>
);

export const EditSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 7.5L5.92819 14.0718C5.71566 14.2843 5.60939 14.3906 5.53953 14.5212C5.46966 14.6517 5.44019 14.7991 5.38124 15.0938L4.64709 18.7646C4.58057 19.0972 4.5473 19.2635 4.64191 19.3581C4.73652 19.4527 4.90283 19.4194 5.23544 19.3529L8.90621 18.6188C9.20093 18.5598 9.3483 18.5303 9.47885 18.4605C9.60939 18.3906 9.71566 18.2843 9.92819 18.0718L16.5 11.5L12.5 7.5Z"
      fill="#7ec1ff"
      fillOpacity="0.25"
    />
    <path
      d="M5.95396 19.38L5.95397 19.38L5.9801 19.3734L5.98012 19.3734L8.60809 18.7164C8.62428 18.7124 8.64043 18.7084 8.65654 18.7044C8.87531 18.65 9.08562 18.5978 9.27707 18.4894C9.46852 18.381 9.62153 18.2275 9.7807 18.0679C9.79242 18.0561 9.80418 18.0444 9.81598 18.0325L17.0101 10.8385L17.0101 10.8385L17.0369 10.8117C17.3472 10.5014 17.6215 10.2272 17.8128 9.97638C18.0202 9.70457 18.1858 9.39104 18.1858 9C18.1858 8.60896 18.0202 8.29543 17.8128 8.02361C17.6215 7.77285 17.3472 7.49863 17.0369 7.18835L17.01 7.16152L16.8385 6.98995L16.8117 6.96314C16.5014 6.6528 16.2272 6.37853 15.9764 6.1872C15.7046 5.97981 15.391 5.81421 15 5.81421C14.609 5.81421 14.2954 5.97981 14.0236 6.1872C13.7729 6.37853 13.4986 6.65278 13.1884 6.96311L13.1615 6.98995L5.96745 14.184C5.95565 14.1958 5.94386 14.2076 5.93211 14.2193C5.77249 14.3785 5.61904 14.5315 5.51064 14.7229C5.40225 14.9144 5.34999 15.1247 5.29562 15.3435C5.29162 15.3596 5.28761 15.3757 5.28356 15.3919L4.62003 18.046C4.61762 18.0557 4.61518 18.0654 4.61272 18.0752C4.57411 18.2293 4.53044 18.4035 4.51593 18.5518C4.49978 18.7169 4.50127 19.0162 4.74255 19.2574C4.98383 19.4987 5.28307 19.5002 5.44819 19.4841C5.59646 19.4696 5.77072 19.4259 5.92479 19.3873C5.9346 19.3848 5.94433 19.3824 5.95396 19.38Z"
      stroke="#1890ff"
      strokeWidth="1.2"
    />
    <path d="M12.5 7.5L16.5 11.5" stroke="#1890ff" strokeWidth="1.2" />
  </svg>
);

export const RightArrowSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 8L21 12M21 12L17 16M21 12H3"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Pros1SVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.9102 27.4385V28.4385H24.9215L24.9328 28.4382L24.9102 27.4385ZM7.48033 27.4385V26.4384L7.4709 26.4385L7.48033 27.4385ZM6.26567 26.3491H5.26567V26.3988L5.27059 26.4482L6.26567 26.3491ZM4.28847 5.22079L3.29575 5.3413L3.3006 5.38127L3.30865 5.42072L4.28847 5.22079ZM4.88217 4.56173L4.86562 5.56159L4.8739 5.56173H4.88217V4.56173ZM27.5084 4.56173L27.5371 3.56214L27.5227 3.56173H27.5084V4.56173ZM27.9768 5.22079L27.0233 4.9193L27.0094 4.96347L26.9995 5.00875L27.9768 5.22079ZM25.8743 26.3491H24.8743V26.3988L24.8792 26.4483L25.8743 26.3491ZM12.8913 24.7149C12.8913 25.2672 13.339 25.7149 13.8913 25.7149C14.4436 25.7149 14.8913 25.2672 14.8913 24.7149H12.8913ZM7.44444 24.7149C7.44444 25.2672 7.89215 25.7149 8.44444 25.7149C8.99672 25.7149 9.44444 25.2672 9.44444 24.7149H7.44444ZM15.5253 17.1787C14.9731 17.1787 14.5253 17.6264 14.5253 18.1787C14.5253 18.731 14.9731 19.1787 15.5253 19.1787V17.1787ZM17.1545 19.1787C17.7068 19.1787 18.1545 18.731 18.1545 18.1787C18.1545 17.6264 17.7068 17.1787 17.1545 17.1787V19.1787ZM15.5253 18.8127C14.9731 18.8127 14.5253 19.2604 14.5253 19.8127C14.5253 20.365 14.9731 20.8127 15.5253 20.8127V18.8127ZM18.5162 20.8127C19.0685 20.8127 19.5162 20.365 19.5162 19.8127C19.5162 19.2604 19.0685 18.8127 18.5162 18.8127V20.8127ZM20.4275 18.8127C19.8752 18.8127 19.4275 19.2604 19.4275 19.8127C19.4275 20.365 19.8752 20.8127 20.4275 20.8127V18.8127ZM23.4183 20.8127C23.9706 20.8127 24.4183 20.365 24.4183 19.8127C24.4183 19.2604 23.9706 18.8127 23.4183 18.8127V20.8127ZM12.2572 11.1871C11.7049 11.1871 11.2572 11.6349 11.2572 12.1871C11.2572 12.7394 11.7049 13.1871 12.2572 13.1871V11.1871ZM19.3381 13.1871C19.8904 13.1871 20.3381 12.7394 20.3381 12.1871C20.3381 11.6349 19.8904 11.1871 19.3381 11.1871V13.1871ZM15.5253 21.5361C14.9731 21.5361 14.5253 21.9839 14.5253 22.5361C14.5253 23.0884 14.9731 23.5361 15.5253 23.5361V21.5361ZM17.1545 23.5361C17.7068 23.5361 18.1545 23.0884 18.1545 22.5361C18.1545 21.9839 17.7068 21.5361 17.1545 21.5361V23.5361ZM15.5204 23.1702C14.9681 23.1702 14.5204 23.6179 14.5204 24.1702C14.5204 24.7225 14.9681 25.1702 15.5204 25.1702V23.1702ZM18.2438 25.1702C18.7961 25.1702 19.2438 24.7225 19.2438 24.1702C19.2438 23.6179 18.7961 23.1702 18.2438 23.1702V25.1702ZM20.4275 23.1702C19.8752 23.1702 19.4275 23.6179 19.4275 24.1702C19.4275 24.7225 19.8752 25.1702 20.4275 25.1702V23.1702ZM23.4183 25.1702C23.9706 25.1702 24.4183 24.7225 24.4183 24.1702C24.4183 23.6179 23.9706 23.1702 23.4183 23.1702V25.1702ZM24.9102 26.4385H7.48033V28.4385H24.9102V26.4385ZM7.4709 26.4385C7.41864 26.439 7.36811 26.4199 7.32924 26.3851L5.9939 27.874C6.40457 28.2423 6.93818 28.4436 7.48975 28.4384L7.4709 26.4385ZM7.32924 26.3851C7.29037 26.3502 7.26593 26.3021 7.26076 26.2501L5.27059 26.4482C5.32523 26.9971 5.58323 27.5057 5.9939 27.874L7.32924 26.3851ZM7.26567 26.3491V14.9107H5.26567V26.3491H7.26567ZM7.24548 14.7108L5.26828 5.02086L3.30865 5.42072L5.28586 15.1107L7.24548 14.7108ZM5.28118 5.10028C5.28828 5.15875 5.28275 5.218 5.26503 5.27404L3.35808 4.6711C3.28968 4.88742 3.2684 5.11594 3.29575 5.3413L5.28118 5.10028ZM5.26503 5.27404C5.24731 5.33009 5.21777 5.38174 5.17836 5.42548L3.69239 4.08687C3.54046 4.25552 3.42648 4.45475 3.35808 4.6711L5.26503 5.27404ZM5.17836 5.42548C5.139 5.46918 5.09071 5.50395 5.03674 5.52744L4.23863 3.69359C4.03052 3.78416 3.84427 3.91827 3.69239 4.08687L5.17836 5.42548ZM5.03674 5.52744C4.98279 5.55092 4.92443 5.56256 4.86562 5.56159L4.89872 3.56186C4.67182 3.55811 4.44673 3.60302 4.23863 3.69359L5.03674 5.52744ZM4.88217 5.56173H27.5084V3.56173H4.88217V5.56173ZM27.4796 5.56131C27.4033 5.55912 27.3285 5.53924 27.2612 5.50326L28.2039 3.73937C27.9984 3.62951 27.7701 3.56884 27.5371 3.56214L27.4796 5.56131ZM27.2612 5.50326C27.194 5.46731 27.1359 5.41622 27.0916 5.35393L28.7218 4.19528C28.5867 4.00524 28.4094 3.8492 28.2039 3.73937L27.2612 5.50326ZM27.0916 5.35393C27.0473 5.29165 27.0182 5.21999 27.0063 5.14465L28.9821 4.83426C28.946 4.60407 28.8569 4.38533 28.7218 4.19528L27.0916 5.35393ZM27.0063 5.14465C26.9945 5.06919 27.0003 4.99206 27.0233 4.9193L28.9303 5.52228C29.0005 5.30007 29.0183 5.06456 28.9821 4.83426L27.0063 5.14465ZM26.9995 5.00875L24.8971 14.6987L26.8516 15.1228L28.9541 5.43283L26.9995 5.00875ZM24.8743 14.9107V26.3491H26.8743V14.9107H24.8743ZM24.8792 26.4483C24.8791 26.4471 24.8793 26.4459 24.8796 26.4447L26.7827 27.0598C26.8671 26.7987 26.8966 26.523 26.8694 26.25L24.8792 26.4483ZM24.8796 26.4447C24.88 26.4436 24.8806 26.4425 24.8814 26.4417L26.3791 27.7671C26.5609 27.5617 26.6983 27.3209 26.7827 27.0598L24.8796 26.4447ZM24.8814 26.4417C24.8822 26.4408 24.8831 26.44 24.8842 26.4395L25.726 28.2537C25.9749 28.1382 26.1973 27.9726 26.3791 27.7671L24.8814 26.4417ZM24.8842 26.4395C24.8853 26.439 24.8865 26.4388 24.8877 26.4387L24.9328 28.4382C25.2071 28.432 25.4772 28.3692 25.726 28.2537L24.8842 26.4395ZM6.26567 15.9107H25.8743V13.9107H6.26567V15.9107ZM11.1679 22.9915C11.8665 22.9915 12.5364 22.7139 13.0304 22.22L11.6162 20.8057C11.4973 20.9247 11.336 20.9915 11.1679 20.9915V22.9915ZM13.0304 22.22C13.5244 21.726 13.8019 21.056 13.8019 20.3574H11.8019C11.8019 20.5256 11.7351 20.6868 11.6162 20.8057L13.0304 22.22ZM13.8019 20.3574V19.8127H11.8019V20.3574H13.8019ZM13.8019 19.8127C13.8019 19.1141 13.5244 18.4441 13.0304 17.9502L11.6162 19.3644C11.7351 19.4833 11.8019 19.6446 11.8019 19.8127H13.8019ZM13.0304 17.9502C12.5364 17.4562 11.8665 17.1787 11.1679 17.1787V19.1787C11.336 19.1787 11.4973 19.2455 11.6162 19.3644L13.0304 17.9502ZM11.1679 17.1787C10.4692 17.1787 9.79928 17.4562 9.30531 17.9502L10.7195 19.3644C10.8384 19.2455 10.9997 19.1787 11.1679 19.1787V17.1787ZM9.30531 17.9502C8.81134 18.4441 8.53381 19.1141 8.53381 19.8127H10.5338C10.5338 19.6446 10.6006 19.4833 10.7195 19.3644L9.30531 17.9502ZM8.53381 19.8127V20.3574H10.5338V19.8127H8.53381ZM8.53381 20.3574C8.53381 21.056 8.81134 21.726 9.30531 22.22L10.7195 20.8057C10.6006 20.6868 10.5338 20.5256 10.5338 20.3574H8.53381ZM9.30531 22.22C9.79928 22.7139 10.4693 22.9915 11.1679 22.9915V20.9915C10.9997 20.9915 10.8384 20.9247 10.7195 20.8057L9.30531 22.22ZM14.8913 24.7149V23.6255H12.8913V24.7149H14.8913ZM14.8913 23.6255C14.8913 22.4365 13.9722 21.7723 13.2967 21.4597C12.5828 21.1294 11.7556 20.9915 11.1679 20.9915V22.9915C11.506 22.9915 12.0406 23.0823 12.4569 23.2749C12.6609 23.3692 12.7831 23.4637 12.8446 23.5337C12.8931 23.5889 12.8913 23.6106 12.8913 23.6255H14.8913ZM11.1679 20.9915C10.5801 20.9915 9.75293 21.1294 9.03902 21.4597C8.36348 21.7723 7.44444 22.4365 7.44444 23.6255H9.44444C9.44444 23.6106 9.44265 23.5889 9.49112 23.5337C9.55264 23.4637 9.67483 23.3692 9.8788 23.2749C10.2951 23.0823 10.8297 22.9915 11.1679 22.9915V20.9915ZM7.44444 23.6255V24.7149H9.44444V23.6255H7.44444ZM15.5253 19.1787H17.1545V17.1787H15.5253V19.1787ZM15.5253 20.8127H18.5162V18.8127H15.5253V20.8127ZM20.4275 20.8127H23.4183V18.8127H20.4275V20.8127ZM12.2572 13.1871H19.3381V11.1871H12.2572V13.1871ZM15.5253 23.5361H17.1545V21.5361H15.5253V23.5361ZM15.5204 25.1702H18.2438V23.1702H15.5204V25.1702ZM20.4275 25.1702H23.4183V23.1702H20.4275V25.1702Z"
      fill="#4DA44E"
    />
  </svg>
);

export const Pros2SVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.00879 20.5738C9.39838 20.1824 9.39687 19.5492 9.00542 19.1596C8.61396 18.77 7.9808 18.7715 7.59121 19.163L9.00879 20.5738ZM5.39121 21.3735C5.00162 21.765 5.00313 22.3981 5.39458 22.7877C5.78604 23.1773 6.4192 23.1758 6.80879 22.7844L5.39121 21.3735ZM10.8042 22.6065C11.1938 22.2151 11.1923 21.5819 10.8008 21.1923C10.4094 20.8027 9.77623 20.8042 9.38664 21.1957L10.8042 22.6065ZM4.98664 25.6167C4.59705 26.0082 4.59856 26.6414 4.99001 27.0309C5.38147 27.4205 6.01463 27.419 6.40422 27.0276L4.98664 25.6167ZM12.6881 24.4105C13.0777 24.0191 13.0762 23.3859 12.6847 22.9963C12.2932 22.6067 11.6601 22.6082 11.2705 22.9997L12.6881 24.4105ZM10.1705 24.105C9.7809 24.4964 9.78241 25.1296 10.1739 25.5192C10.5653 25.9088 11.1985 25.9073 11.5881 25.5158L10.1705 24.105ZM19.3423 10.5239V9.52392V10.5239ZM26.8288 5.65731L27.7945 5.39754C27.6988 5.04181 27.4153 4.7675 27.0566 4.68359L26.8288 5.65731ZM9.4 18.4717L8.53023 17.9783C8.30276 18.3792 8.37883 18.8837 8.71441 19.1997L9.4 18.4717ZM13.2303 22.0789L12.5447 22.8069C12.8508 23.0953 13.3047 23.1612 13.6802 22.972L13.2303 22.0789ZM11.7181 13.1246C12.2665 13.0593 12.6582 12.5619 12.593 12.0135C12.5278 11.465 12.0303 11.0733 11.4819 11.1386L11.7181 13.1246ZM5 16.5526L4.17692 15.9847C3.9222 16.3539 3.94443 16.8475 4.23129 17.1922C4.51816 17.537 4.99949 17.6486 5.40881 17.4653L5 16.5526ZM8.60909 17.3583C9.15249 17.457 9.67299 17.0965 9.77167 16.5531C9.87035 16.0097 9.50983 15.4892 8.96643 15.3905L8.60909 17.3583ZM21.3263 20.0116C21.4054 19.465 21.0264 18.9578 20.4798 18.8787C19.9332 18.7997 19.426 19.1787 19.3469 19.7253L21.3263 20.0116ZM14.8366 26.5L13.9605 26.0179C13.7455 26.4086 13.8152 26.8944 14.1313 27.2089C14.4474 27.5234 14.9335 27.5906 15.3231 27.3737L14.8366 26.5ZM16.0344 22.476C15.914 21.937 15.3794 21.5977 14.8404 21.7182C14.3014 21.8386 13.9621 22.3732 14.0826 22.9122L16.0344 22.476ZM7.59121 19.163L5.39121 21.3735L6.80879 22.7844L9.00879 20.5738L7.59121 19.163ZM9.38664 21.1957L4.98664 25.6167L6.40422 27.0276L10.8042 22.6065L9.38664 21.1957ZM11.2705 22.9997L10.1705 24.105L11.5881 25.5158L12.6881 24.4105L11.2705 22.9997ZM19.3423 11.5239C19.5785 11.5239 19.8099 11.5943 20.0071 11.7267L21.1219 10.0662C20.5956 9.71284 19.9762 9.52392 19.3423 9.52392V11.5239ZM20.0071 11.7267C20.2044 11.8592 20.3589 12.0479 20.4503 12.2696L22.2993 11.5074C22.0577 10.9213 21.6482 10.4196 21.1219 10.0662L20.0071 11.7267ZM20.4503 12.2696C20.5417 12.4914 20.5657 12.7357 20.519 12.9715L22.481 13.3599C22.6041 12.7381 22.5409 12.0935 22.2993 11.5074L20.4503 12.2696ZM20.519 12.9715C20.4724 13.2072 20.3573 13.4231 20.1891 13.5921L21.6067 15.0029C22.0539 14.5536 22.3579 13.9818 22.481 13.3599L20.519 12.9715ZM20.1891 13.5921C20.021 13.761 19.8073 13.8756 19.5755 13.9219L19.9675 15.8831C20.5891 15.7589 21.1595 15.4523 21.6067 15.0029L20.1891 13.5921ZM19.5755 13.9219C19.3436 13.9682 19.1033 13.9445 18.8846 13.8535L18.1161 15.6999C18.7014 15.9436 19.3458 16.0074 19.9675 15.8831L19.5755 13.9219ZM18.8846 13.8535C18.6659 13.7624 18.4782 13.608 18.3457 13.4088L16.6803 14.5163C17.0314 15.0442 17.5309 15.4564 18.1161 15.6999L18.8846 13.8535ZM18.3457 13.4088C18.2133 13.2096 18.1423 12.9749 18.1423 12.7345H16.1423C16.1423 13.3684 16.3293 13.9885 16.6803 14.5163L18.3457 13.4088ZM18.1423 12.7345C18.1423 12.4119 18.2699 12.1035 18.4954 11.8768L17.0778 10.466C16.4783 11.0684 16.1423 11.8845 16.1423 12.7345H18.1423ZM18.4954 11.8768C18.7208 11.6503 19.0256 11.5239 19.3423 11.5239V9.52392C18.492 9.52392 17.6776 9.86335 17.0778 10.466L18.4954 11.8768ZM20.7912 7.31068L25.1912 11.7317L26.6088 10.3209L22.2088 5.89985L20.7912 7.31068ZM27.0566 4.68359C26.249 4.49468 23.6891 4.11007 20.2646 5.67221C16.8448 7.23223 12.6676 10.6859 8.53023 17.9783L10.2698 18.9652C14.2567 11.9379 18.1521 8.83416 21.0947 7.49183C24.0326 6.15162 26.125 6.51966 26.601 6.63102L27.0566 4.68359ZM8.71441 19.1997L12.5447 22.8069L13.9159 21.351L10.0856 17.7437L8.71441 19.1997ZM13.6802 22.972C21.4284 19.068 25.0999 15.1257 26.7586 11.8795C28.4259 8.61655 28.0022 6.16961 27.7945 5.39754L25.8631 5.91707C25.9702 6.31492 26.3746 8.23563 24.9776 10.9695C23.5722 13.72 20.287 17.4036 12.7803 21.1859L13.6802 22.972ZM11.4819 11.1386C9.5783 11.365 6.69508 12.3352 4.17692 15.9847L5.82308 17.1206C7.97675 13.9993 10.3141 13.2916 11.7181 13.1246L11.4819 11.1386ZM5 16.5526C5.40881 17.4653 5.4084 17.4654 5.408 17.4656C5.40788 17.4657 5.40748 17.4658 5.40723 17.466C5.40672 17.4662 5.40624 17.4664 5.40577 17.4666C5.40484 17.467 5.40399 17.4674 5.40321 17.4677C5.40167 17.4684 5.40045 17.4689 5.39954 17.4693C5.39773 17.4701 5.39719 17.4703 5.39791 17.47C5.39936 17.4694 5.40585 17.4668 5.4173 17.4625C5.44022 17.4538 5.48295 17.4385 5.54487 17.4195C5.66868 17.3817 5.86917 17.3295 6.1414 17.2876C6.68431 17.2041 7.51922 17.1604 8.60909 17.3583L8.96643 15.3905C7.64418 15.1504 6.58521 15.1958 5.83727 15.3109C5.46407 15.3683 5.16989 15.4428 4.9604 15.5068C4.85566 15.5389 4.77208 15.5682 4.71034 15.5916C4.67947 15.6032 4.65405 15.6134 4.63417 15.6216C4.62422 15.6257 4.61567 15.6293 4.6085 15.6324C4.60492 15.634 4.60168 15.6354 4.5988 15.6366C4.59736 15.6373 4.596 15.6379 4.59473 15.6384C4.5941 15.6387 4.59349 15.639 4.5929 15.6392C4.5926 15.6394 4.59218 15.6396 4.59203 15.6396C4.59161 15.6398 4.59119 15.64 5 16.5526ZM19.3469 19.7253C19.1538 21.0604 18.309 23.4219 14.3501 25.6263L15.3231 27.3737C19.7945 24.8839 21.0388 21.9999 21.3263 20.0116L19.3469 19.7253ZM14.8366 26.5C15.7128 26.9821 15.713 26.9816 15.7133 26.9812C15.7134 26.981 15.7136 26.9805 15.7138 26.9802C15.7141 26.9796 15.7145 26.9789 15.7149 26.9782C15.7156 26.9769 15.7164 26.9754 15.7172 26.9739C15.7189 26.9708 15.7207 26.9674 15.7227 26.9636C15.7268 26.956 15.7314 26.9469 15.7367 26.9365C15.7473 26.9156 15.7604 26.8891 15.7753 26.8569C15.8052 26.7926 15.8426 26.7059 15.8834 26.5974C15.965 26.3804 16.0598 26.0762 16.1328 25.6908C16.2796 24.9169 16.3364 23.8275 16.0344 22.476L14.0826 22.9122C14.3213 23.9806 14.2672 24.7941 14.1678 25.3182C14.1179 25.5818 14.0558 25.7753 14.0113 25.8938C13.989 25.9531 13.9711 25.9935 13.9614 26.0145C13.9565 26.025 13.9537 26.0306 13.9534 26.0312C13.9532 26.0315 13.9537 26.0305 13.9549 26.0283C13.9555 26.0272 13.9562 26.0258 13.9571 26.0241C13.9576 26.0232 13.9581 26.0223 13.9587 26.0213C13.959 26.0207 13.9592 26.0202 13.9595 26.0197C13.9597 26.0194 13.9599 26.019 13.96 26.0188C13.9602 26.0184 13.9605 26.0179 14.8366 26.5Z"
      fill="#FABB18"
    />
  </svg>
);

export const Pros3SVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7938 24.4055L14.302 23.5442L13.7938 24.4055ZM18.2062 24.4055L17.698 23.5442L18.2062 24.4055ZM13.7381 14.6402C13.3171 14.2828 12.6861 14.3343 12.3286 14.7554C11.9712 15.1764 12.0228 15.8074 12.4438 16.1649L13.7381 14.6402ZM15.2728 17.2548L14.6256 18.0171C14.8281 18.189 15.0906 18.2733 15.3553 18.2514C15.6199 18.2295 15.865 18.1032 16.0365 17.9003L15.2728 17.2548ZM19.6729 13.5984C20.0294 13.1767 19.9765 12.5457 19.5547 12.1892C19.1329 11.8326 18.502 11.8855 18.1454 12.3073L19.6729 13.5984ZM12 7.5H20V5.5H12V7.5ZM23 10.5V15.8208H25V10.5H23ZM9 15.8208V10.5H7V15.8208H9ZM14.302 23.5442C11.1459 21.6819 9 18.9216 9 15.8208H7C7 19.9085 9.80643 23.2138 13.2856 25.2667L14.302 23.5442ZM23 15.8208C23 18.9216 20.8541 21.6819 17.698 23.5442L18.7144 25.2667C22.1936 23.2138 25 19.9085 25 15.8208H23ZM13.2856 25.2667C14.9591 26.2542 17.0409 26.2542 18.7144 25.2667L17.698 23.5442C16.6516 24.1617 15.3484 24.1617 14.302 23.5442L13.2856 25.2667ZM20 7.5C21.6569 7.5 23 8.84315 23 10.5H25C25 7.73858 22.7614 5.5 20 5.5V7.5ZM12 5.5C9.23858 5.5 7 7.73858 7 10.5H9C9 8.84315 10.3431 7.5 12 7.5V5.5ZM12.4438 16.1649L14.6256 18.0171L15.92 16.4924L13.7381 14.6402L12.4438 16.1649ZM16.0365 17.9003L19.6729 13.5984L18.1454 12.3073L14.5091 16.6092L16.0365 17.9003Z"
      fill="#2972E1"
    />
  </svg>
);

export const DotsSVG = () => (
  <svg
    width="36"
    height="8"
    viewBox="0 0 36 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="4" cy="4" r="4" fill="#F23936" />
    <circle cx="18" cy="4" r="4" fill="#FABB18" />
    <circle cx="32" cy="4" r="4" fill="#008EFF" />
  </svg>
);

export const SuccesSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#14B082" fillOpacity="0.7" />
    <path
      d="M24.9061 9.71922C24.7826 9.59696 24.6357 9.49992 24.4738 9.43369C24.312 9.36747 24.1384 9.33337 23.963 9.33337C23.7877 9.33337 23.6141 9.36747 23.4522 9.43369C23.2904 9.49992 23.1435 9.59696 23.02 9.71922L13.1247 19.4503L8.96737 15.3543C8.83917 15.2327 8.68783 15.1371 8.522 15.0729C8.35616 15.0087 8.17908 14.9773 8.00085 14.9803C7.82263 14.9833 7.64676 15.0208 7.48329 15.0906C7.31981 15.1603 7.17193 15.2611 7.04809 15.387C6.92425 15.5129 6.82687 15.6615 6.76152 15.8244C6.69616 15.9872 6.66411 16.1611 6.6672 16.3362C6.67028 16.5112 6.70844 16.6839 6.77949 16.8445C6.85054 17.005 6.95309 17.1502 7.08129 17.2719L12.1817 22.2809C12.3052 22.4031 12.4521 22.5002 12.6139 22.5664C12.7758 22.6326 12.9494 22.6667 13.1247 22.6667C13.3001 22.6667 13.4737 22.6326 13.6355 22.5664C13.7974 22.5002 13.9443 22.4031 14.0678 22.2809L24.9061 11.6367C25.0409 11.5146 25.1485 11.3663 25.2221 11.2013C25.2957 11.0363 25.3337 10.8581 25.3337 10.678C25.3337 10.4978 25.2957 10.3196 25.2221 10.1546C25.1485 9.98962 25.0409 9.84137 24.9061 9.71922Z"
      fill="white"
    />
  </svg>
);

export const Num1SVG = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="white" />
    <path
      d="M21.992 35V14.2L23.816 16.088H17.256V12.6H26.152V35H21.992Z"
      fill="black"
    />
  </svg>
);

export const Num2SVG = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="white" />
    <path
      d="M15.3075 35V32.216L24.2035 23.768C24.9502 23.064 25.5048 22.4453 25.8675 21.912C26.2302 21.3787 26.4648 20.888 26.5715 20.44C26.6995 19.9707 26.7635 19.5333 26.7635 19.128C26.7635 18.104 26.4115 17.3147 25.7075 16.76C25.0035 16.184 23.9688 15.896 22.6035 15.896C21.5155 15.896 20.5235 16.088 19.6275 16.472C18.7528 16.856 17.9955 17.4427 17.3555 18.232L14.4435 15.992C15.3182 14.8187 16.4915 13.912 17.9635 13.272C19.4568 12.6107 21.1208 12.28 22.9555 12.28C24.5768 12.28 25.9848 12.5467 27.1795 13.08C28.3955 13.592 29.3235 14.328 29.9635 15.288C30.6248 16.248 30.9555 17.3893 30.9555 18.712C30.9555 19.4373 30.8595 20.1627 30.6675 20.888C30.4755 21.592 30.1128 22.3387 29.5795 23.128C29.0462 23.9173 28.2675 24.8027 27.2435 25.784L19.5955 33.048L18.7315 31.48H31.8195V35H15.3075Z"
      fill="black"
    />
  </svg>
);

export const Num3SVG = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="white" />
    <path
      d="M22.448 35.32C20.8693 35.32 19.3227 35.096 17.808 34.648C16.3147 34.1787 15.056 33.5387 14.032 32.728L15.824 29.496C16.6347 30.1573 17.616 30.6907 18.768 31.096C19.92 31.5013 21.1253 31.704 22.384 31.704C23.8773 31.704 25.04 31.4053 25.872 30.808C26.704 30.1893 27.12 29.3573 27.12 28.312C27.12 27.288 26.736 26.4773 25.968 25.88C25.2 25.2827 23.9627 24.984 22.256 24.984H20.208V22.136L26.608 14.52L27.152 16.088H15.12V12.6H30.384V15.384L23.984 23L21.808 21.72H23.056C25.808 21.72 27.8667 22.3387 29.232 23.576C30.6187 24.792 31.312 26.36 31.312 28.28C31.312 29.5387 30.992 30.7013 30.352 31.768C29.712 32.8347 28.7307 33.6987 27.408 34.36C26.1067 35 24.4533 35.32 22.448 35.32Z"
      fill="black"
    />
  </svg>
);

export const TelegramBigSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.4142 15.565C5.21978 14.0196 8.35158 12.7298 11.2778 11.4334C16.312 9.30999 21.3662 7.22338 26.4714 5.28078C27.4647 4.94978 29.2494 4.62608 29.4244 6.09808C29.3286 8.18168 28.9344 10.2531 28.664 12.3245C27.9777 16.8797 27.1845 21.4193 26.411 25.9595C26.1445 27.4718 24.25 28.2547 23.0378 27.2869C20.1246 25.3191 17.189 23.3705 14.313 21.3571C13.3709 20.3998 14.2445 19.0251 15.0859 18.3415C17.4853 15.9769 20.0299 13.9679 22.3039 11.4811C22.9173 9.99978 21.1049 11.2482 20.5071 11.6307C17.2223 13.8943 14.0179 16.2961 10.5547 18.2855C8.78568 19.2593 6.72388 18.4271 4.95568 17.8837C3.37026 17.2273 1.04704 16.566 2.41404 15.5651L2.4142 15.565Z"
      fill="white"
    />
  </svg>
);

export const DownloadSVg = ({ color = "#1890FF" }) => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.6203 12H20.5003V5.33333C20.5003 4.6 19.9003 4 19.167 4H13.8337C13.1003 4 12.5003 4.6 12.5003 5.33333V12H10.3803C9.19366 12 8.59366 13.44 9.43366 14.28L15.5537 20.4C16.0737 20.92 16.9137 20.92 17.4337 20.4L23.5537 14.28C24.3937 13.44 23.807 12 22.6203 12ZM7.16699 25.3333C7.16699 26.0667 7.76699 26.6667 8.50033 26.6667H24.5003C25.2337 26.6667 25.8337 26.0667 25.8337 25.3333C25.8337 24.6 25.2337 24 24.5003 24H8.50033C7.76699 24 7.16699 24.6 7.16699 25.3333Z"
      fill={color}
    />
  </svg>
);

export const FileSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 2C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8.83C20 8.3 19.79 7.79 19.41 7.42L14.58 2.59C14.21 2.21 13.7 2 13.17 2H6ZM13 8V3.5L18.5 9H14C13.45 9 13 8.55 13 8Z"
      fill="#8C8C8C"
    />
  </svg>
);

export const AlertSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0015 21.75C13.1015 21.75 14.0015 20.85 14.0015 19.75H10.0015C10.0015 20.85 10.8915 21.75 12.0015 21.75ZM18.0015 15.75V10.75C18.0015 7.68 16.3615 5.11 13.5015 4.43V3.75C13.5015 2.92 12.8315 2.25 12.0015 2.25C11.1715 2.25 10.5015 2.92 10.5015 3.75V4.43C7.63152 5.11 6.00152 7.67 6.00152 10.75V15.75L4.71152 17.04C4.08152 17.67 4.52152 18.75 5.41152 18.75H18.5815C19.4715 18.75 19.9215 17.67 19.2915 17.04L18.0015 15.75Z"
      fill="#8C8C8C"
    />
  </svg>
);

export const ResultSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.41 7.41L14.58 2.58C14.21 2.21 13.7 2 13.17 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8.83C20 8.3 19.79 7.79 19.41 7.41ZM10.23 17.29L8.11 15.17C7.72 14.78 7.72 14.15 8.11 13.76C8.5 13.37 9.13 13.37 9.52 13.76L10.93 15.17L14.47 11.63C14.86 11.24 15.49 11.24 15.88 11.63C16.27 12.02 16.27 12.65 15.88 13.04L11.64 17.28C11.26 17.68 10.62 17.68 10.23 17.29ZM14 9C13.45 9 13 8.55 13 8V3.5L18.5 9H14Z"
      fill="#8C8C8C"
    />
  </svg>
);
export const UserSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.25 9C15.25 10.7949 13.7949 12.25 12 12.25V13.75C14.6234 13.75 16.75 11.6234 16.75 9H15.25ZM12 12.25C10.2051 12.25 8.75 10.7949 8.75 9H7.25C7.25 11.6234 9.37665 13.75 12 13.75V12.25ZM8.75 9C8.75 7.20507 10.2051 5.75 12 5.75V4.25C9.37665 4.25 7.25 6.37665 7.25 9H8.75ZM12 5.75C13.7949 5.75 15.25 7.20507 15.25 9H16.75C16.75 6.37665 14.6234 4.25 12 4.25V5.75ZM9 16.75H15V15.25H9V16.75ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75V1.25C6.06294 1.25 1.25 6.06294 1.25 12H2.75ZM12 2.75C17.1086 2.75 21.25 6.89137 21.25 12H22.75C22.75 6.06294 17.9371 1.25 12 1.25V2.75ZM21.25 12C21.25 14.6233 20.159 16.9905 18.4039 18.6748L19.4425 19.7571C21.4801 17.8016 22.75 15.0485 22.75 12H21.25ZM18.4039 18.6748C16.7412 20.2705 14.4858 21.25 12 21.25V22.75C14.8882 22.75 17.5117 21.61 19.4425 19.7571L18.4039 18.6748ZM15 16.75C16.576 16.75 17.8915 17.8726 18.1876 19.3621L19.6588 19.0697C19.226 16.8918 17.3055 15.25 15 15.25V16.75ZM12 21.25C9.51425 21.25 7.25884 20.2705 5.59612 18.6748L4.55751 19.7571C6.48833 21.61 9.11182 22.75 12 22.75V21.25ZM5.59612 18.6748C3.84103 16.9905 2.75 14.6233 2.75 12H1.25C1.25 15.0485 2.51989 17.8016 4.55751 19.7571L5.59612 18.6748ZM9 15.25C6.69445 15.25 4.77403 16.8918 4.3412 19.0697L5.81243 19.3621C6.10846 17.8726 7.42396 16.75 9 16.75V15.25Z"
      fill="#8C8C8C"
    />
    <path
      d="M15.0001 16H9.00009C7.0593 16 5.44134 17.3822 5.0769 19.2159C6.87368 20.9403 9.31313 22 12.0001 22C14.6871 22 17.1265 20.9403 18.9233 19.2159C18.5588 17.3822 16.9409 16 15.0001 16Z"
      fill="#8C8C8C"
    />
    <path
      d="M18.9233 19.2159L19.4426 19.7571L19.739 19.4726L19.6589 19.0697L18.9233 19.2159ZM5.0769 19.2159L4.34129 19.0697L4.26122 19.4726L4.5576 19.7571L5.0769 19.2159ZM9.00009 16.75H15.0001V15.25H9.00009V16.75ZM18.404 18.6748C16.7413 20.2705 14.4858 21.25 12.0001 21.25V22.75C14.8883 22.75 17.5118 21.61 19.4426 19.7571L18.404 18.6748ZM15.0001 16.75C16.5761 16.75 17.8916 17.8726 18.1877 19.3621L19.6589 19.0697C19.2261 16.8918 17.3056 15.25 15.0001 15.25V16.75ZM12.0001 21.25C9.51434 21.25 7.25893 20.2705 5.59621 18.6748L4.5576 19.7571C6.48842 21.61 9.11191 22.75 12.0001 22.75V21.25ZM9.00009 15.25C6.69454 15.25 4.77412 16.8918 4.34129 19.0697L5.81252 19.3621C6.10855 17.8726 7.42405 16.75 9.00009 16.75V15.25Z"
      fill="#8C8C8C"
    />
    <path
      d="M16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9Z"
      fill="#8C8C8C"
    />
    <path
      d="M15.25 9C15.25 10.7949 13.7949 12.25 12 12.25V13.75C14.6234 13.75 16.75 11.6234 16.75 9H15.25ZM12 12.25C10.2051 12.25 8.75 10.7949 8.75 9H7.25C7.25 11.6234 9.37665 13.75 12 13.75V12.25ZM8.75 9C8.75 7.20507 10.2051 5.75 12 5.75V4.25C9.37665 4.25 7.25 6.37665 7.25 9H8.75ZM12 5.75C13.7949 5.75 15.25 7.20507 15.25 9H16.75C16.75 6.37665 14.6234 4.25 12 4.25V5.75Z"
      fill="#8C8C8C"
    />
  </svg>
);

export const FolderSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.59 4.59C10.21 4.21 9.7 4 9.17 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10.59 4.59Z"
      fill="#8C8C8C"
    />
  </svg>
);

export const DateSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 11.53C15.71 11.24 15.23 11.24 14.94 11.53L10.59 15.88L9 14.29C8.71 14 8.23 14 7.94 14.29C7.65 14.58 7.65 15.06 7.94 15.35L9.88 17.29C10.27 17.68 10.9 17.68 11.29 17.29L15.99 12.59C16.29 12.3 16.29 11.82 16 11.53ZM19 4H18V3C18 2.45 17.55 2 17 2C16.45 2 16 2.45 16 3V4H8V3C8 2.45 7.55 2 7 2C6.45 2 6 2.45 6 3V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM18 20H6C5.45 20 5 19.55 5 19V9H19V19C19 19.55 18.55 20 18 20Z"
      fill="#8C8C8C"
    />
  </svg>
);

export const BinoSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 3H12C11.45 3 11 3.45 11 4V5.61C11 5.61 11 5.61 11.01 5.62L16.01 10.12C16.64 10.68 17 11.5 17 12.35V13H19V15H17V17H19V19H17V21H20C20.55 21 21 20.55 21 20V4C21 3.45 20.55 3 20 3ZM15 7H13V5H15V7ZM19 11H17V9H19V11ZM19 7H17V5H19V7Z"
      fill="#8C8C8C"
    />
    <path
      d="M15 20V12.35C15 12.07 14.88 11.8 14.67 11.61L9.67 7.11C9.48 6.93 9.24 6.85 9 6.85C8.76 6.85 8.52 6.94 8.33 7.11L3.33 11.61C3.12 11.79 3 12.06 3 12.35V20C3 20.55 3.45 21 4 21H6C6.55 21 7 20.55 7 20V16H11V20C11 20.55 11.45 21 12 21H14C14.55 21 15 20.55 15 20Z"
      fill="#8C8C8C"
    />
  </svg>
);

export const RightLinkSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 19L13.59 17.59L18.17 13H2V11H18.17L13.58 6.41L15 5L22 12L15 19Z"
      fill="#1890FF"
    />
  </svg>
);

export const DoneSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#219653" />
    <path
      d="M13.8794 21.1859L9.63672 16.9433L11.5234 15.0566L13.8794 17.4192L20.478 10.814L22.3646 12.7006L13.8794 21.1859Z"
      fill="white"
    />
  </svg>
);

export const AcceptSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#FADB14" />
    <rect width="16" height="16" transform="translate(8 8)" fill="#FADB14" />
    <path
      d="M13.8794 21.1859L9.63672 16.9433L11.5234 15.0566L13.8794 17.4192L20.478 10.814L22.3646 12.7006L13.8794 21.1859Z"
      fill="white"
    />
  </svg>
);

export const UnfinishSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#E9E9E9" />
    <path
      d="M13.8794 21.1859L9.63672 16.9433L11.5234 15.0566L13.8794 17.4192L20.478 10.814L22.3646 12.7006L13.8794 21.1859Z"
      fill="#979797"
    />
  </svg>
);

export const HomeSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5492 2.53318C11.3872 1.82618 12.6128 1.82618 13.4508 2.53318L20.2008 8.22772C20.7076 8.65523 21 9.28447 21 9.94747V19.7504C21 20.7169 20.2165 21.5004 19.25 21.5004H16.25C15.2835 21.5004 14.5 20.7169 14.5 19.7504V14.7504C14.5 14.3362 14.1642 14.0004 13.75 14.0004H10.25C9.83579 14.0004 9.5 14.3362 9.5 14.7504V19.7504C9.5 20.7169 8.7165 21.5004 7.75 21.5004H4.75C3.7835 21.5004 3 20.7169 3 19.7504V9.94747C3 9.28447 3.29241 8.65523 3.79916 8.22772L10.5492 2.53318Z"
      fill="#212121"
    />
  </svg>
);

export const RightSVG = () => (
  <svg
    width="5"
    height="8"
    viewBox="0 0 5 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.221001 1.25871C-0.0911684 0.954347 -0.0700798 0.479854 0.268104 0.198901C0.606288 -0.0820516 1.1335 -0.0630718 1.44567 0.241293L4.779 3.49129C5.07367 3.77859 5.07367 4.22141 4.779 4.50871L1.44567 7.75871C1.1335 8.06307 0.606288 8.08205 0.268104 7.8011C-0.0700798 7.52015 -0.0911684 7.04565 0.221001 6.74129L3.03258 4L0.221001 1.25871Z"
      fill="#1A1A1A"
      fillOpacity="0.3"
    />
  </svg>
);

export const TargetSVG = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 7C8.79 7 7 8.79 7 11C7 13.21 8.79 15 11 15C13.21 15 15 13.21 15 11C15 8.79 13.21 7 11 7ZM19.94 10C19.48 5.83 16.17 2.52 12 2.06V0H10V2.06C5.83 2.52 2.52 5.83 2.06 10H0V12H2.06C2.52 16.17 5.83 19.48 10 19.94V22H12V19.94C16.17 19.48 19.48 16.17 19.94 12H22V10H19.94ZM11 18C7.13 18 4 14.87 4 11C4 7.13 7.13 4 11 4C14.87 4 18 7.13 18 11C18 14.87 14.87 18 11 18Z"
      fill="#8C8C8C"
    />
  </svg>
);

export const MyInfo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    width="550"
    height="550"
    viewBox="0 0 550 550"
  >
    <path
      d="M528.35053,230.24577c-8.74377,15.063,7.72065,40.4432-8.87275,45.71354l1.367-1.367c10.0162-12.32036-10.919-38.397-.90274-50.71737a30.10219,30.10219,0,0,0,3.97967-5.91559"
      transform="translate(-241.16498 -177.71861)"
      fill="#2f2e41"
    />
    <path
      d="M610.23656,451.23117a10.49546,10.49546,0,0,0-10.19069-12.456L578.43258,375.982l-11.96325,15.2489L589.321,449.904a10.55234,10.55234,0,0,0,20.91553,1.32714Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#ffb8b8"
    />
    <path
      d="M515.23087,299.62387s-.67244-22.7304,19.65389-9.70908S599.46694,424.9139,599.46694,424.9139l-22.0235,11.9154L527.44685,325.20578Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#0879f9"
    />
    <polygon
      points="334.034 511.488 323.884 515.825 302.324 478.74 317.305 472.338 334.034 511.488"
      fill="#ffb6b6"
    />
    <path
      d="M588.0705,704.50277l-7.27882,3.11037-4.2358-6.31688-.391,8.294-19.30517,8.24944a4.71923,4.71923,0,0,1-5.84632-6.857l10.86679-17.235-2.96876-6.94743,16.62909-5.96133Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#2f2e41"
    />
    <polygon
      points="174.924 524.067 163.9 523.528 160.731 480.749 177.003 481.544 174.924 524.067"
      fill="#ffb6b6"
    />
    <path
      d="M420.97453,721.17129l-7.9061-.38639-1.0464-7.53326-3.9791,7.28765-20.96886-1.0248a4.71924,4.71924,0,0,1-2.25849-8.72338l17.3103-10.74639.3688-7.54615,17.56156,1.91205Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#2f2e41"
    />
    <path
      d="M740.917,694.96942a3.56386,3.56386,0,0,0,2.52393-6.20136c-.09328-.35631-.1602-.61214-.25341-.9685a9.57475,9.57475,0,0,1,17.74853-.33644c4.31772,9.84579,9.88142,20.02805,7.26661,30.94266,17.594-38.22733,11.03667-85.50773-15.81028-117.80021-7.37364-3.97084-13.38731-11.09312-15.01445-19.41415,3.642,1.19546,8.14-1.80049,5.37412-5.59841-1.197-1.45023-2.40544-2.88879-3.60237-4.33908,13.65013-14.81754,30.30051,8.10753,15.31045,28.074a114.26429,114.26429,0,0,1,13.024,19.95055,48.04331,48.04331,0,0,1,2.65565-22.34155c2.68222-6.64886,7.77474-12.27553,12.25158-18.044,5.443-7.02861,16.81306-3.91815,17.6387,4.92755-5.06867,1.71965-5.65929,9.07055.16646,10.02036-1.36654,16.48349-11.98172,31.72082-26.73177,39.08465a114.70968,114.70968,0,0,1,6.72483,47.88518c2.43494-19.011,22.77131-23.8125,36.94436-31.49419a5.54912,5.54912,0,0,1,8.516,5.53977,32.05186,32.05186,0,0,0-5.58948,3.01718,4.84411,4.84411,0,0,0,2.33454,8.8211c-7.01111,17.83933-25.46154,29.94946-44.52854,30.06384a117.92872,117.92872,0,0,1-7.70134,23.201l-28.29843.26948c-.10449-.31345-.19885-.63723-.29316-.95078a32.15277,32.15277,0,0,0,7.82585-.5411c-7.00816-8.139-12.40748-12.27406-8.48327-23.76706Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#f2f2f2"
    />
    <path
      d="M443.93871,423.70394s-22.419,61.09728-22.78123,67.93447-6.75591,93.29728-12.11811,98.3209-21.75591,82.90815-9,89,53-4,53-4l14-92,4.75591-70.48371s14.4788,165.97637,40.7394,165.48819,58.2606-10.48819,58.2606-10.48819L534.03937,566.95931s.51968-118.99873-8-143S443.93871,423.70394,443.93871,423.70394Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#2f2e41"
    />
    <path
      d="M510.46306,266.29342l-30.02424,2.75011-4.8369,14.84778s-25.12627,13.799-19.56255,20.068-1.24409,48.51629-1.24409,48.51629l1.53763,34.29291s-1.65173,23.75888-6.59468,29.233-17.87482,18.89736-8.73744,12.47537c32.03858-22.51755,88.03858-3.51755,88.03858-3.51755l-8-49s18.171-80.2247,11-87-13.937-7.63165-13.937-7.63165Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#0879f9"
    />
    <path
      d="M352.699,421.72134a10.49547,10.49547,0,0,0,7.899-14.02168l50.6395-42.96233-18.55467-5.60111L346.3317,401.75441a10.55234,10.55234,0,0,0,6.3673,19.96693Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#ffb8b8"
    />
    <path
      d="M481.30457,309.34381s9.9774-20.43464-13.90837-16.944-114.46472,96.40252-114.46472,96.40252L368.09,408.733l91.544-81.11205Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#0879f9"
    />
    <path
      d="M442.4072,274.68222,347.70481,396.00816a10.08064,10.08064,0,0,0,1.74093,14.12657c21.99237,53.3988,87.78748,92.9964,165.1861,128.938a10.07423,10.07423,0,0,0,14.12658-1.741l94.70239-121.32594a10.07419,10.07419,0,0,0-1.741-14.12659c-64.952-36.67587-120.77823-79.16815-165.1861-128.93795A10.0806,10.0806,0,0,0,442.4072,274.68222Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#e6e6e6"
    />
    <path
      d="M616.814,413.24549l-28.82644,36.93038a107.91279,107.91279,0,0,1-151.02282,18.612L356.18,405.73035a5.73345,5.73345,0,0,1-.99832-8.03743l91.51114-117.23753a5.73348,5.73348,0,0,1,8.03933-.983c40.86527,52.76917,95.56689,93.83378,161.09216,125.74238A5.728,5.728,0,0,1,616.814,413.24549Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#fff"
    />
    <path
      d="M440.518,340.91459,421.74459,364.9657a3.05106,3.05106,0,0,1-4.81022-3.75468l18.77338-24.05111a3.05106,3.05106,0,1,1,4.81022,3.75468Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#ccc"
    />
    <path
      d="M475.73121,323.07417l-41.22784,52.81817a3.05106,3.05106,0,0,1-4.81023-3.75468L470.921,319.3195a3.05106,3.05106,0,1,1,4.81022,3.75467Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#ccc"
    />
    <circle cx="164.25091" cy="213.35969" r="20.09591" fill="#0879f9" />
    <path
      d="M477.92013,364.8182l-50.63607,64.87132a3.07083,3.07083,0,0,1-4.81022-3.75468l50.63607-64.87131a3.07083,3.07083,0,0,1,4.81022,3.75467Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#ccc"
    />
    <path
      d="M510.7689,350.007l-70.67559,90.54451a3.07083,3.07083,0,0,1-4.81022-3.75468l70.67558-90.5445a3.07083,3.07083,0,0,1,4.81023,3.75467Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#ccc"
    />
    <path
      d="M510.5235,390.26715l-50.63607,64.87132a3.07083,3.07083,0,0,1-4.81022-3.75468l50.63607-64.87131a3.07083,3.07083,0,0,1,4.81022,3.75467Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#ccc"
    />
    <path
      d="M577.5235,398.26715l-50.63607,64.87132a3.07083,3.07083,0,0,1-4.81022-3.75468l50.63607-64.87131a3.07083,3.07083,0,0,1,4.81022,3.75467Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#0879f9"
    />
    <path
      d="M543.37227,375.45593l-70.67559,90.54451a3.07083,3.07083,0,0,1-4.81022-3.75468l70.67559-90.5445a3.07083,3.07083,0,0,1,4.81022,3.75467Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#ccc"
    />
    <path
      d="M460.1263,227.96223A29.82287,29.82287,0,1,0,511.42163,207.277l-.14314-.143c-.2386-.25061-.4772-.50107-.72774-.73974a.01167.01167,0,0,1-.01186-.01194c-.31017-.28629-.62034-.57258-.94245-.84693a29.815,29.815,0,0,0-49.47014,22.42686Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#2f2e41"
    />
    <circle cx="256.13166" cy="57.14378" r="25.00775" fill="#ffb8b8" />
    <path
      d="M470.637,241.52685c-2.44434-11.01562,1.08886-23.35693,8.792-30.71093a28.19911,28.19911,0,0,1,29.44824-5.708c.62891.2539,1.25781.53174,1.875.82177l.28711.13526v.042c.05566.03857.11133.0791.167.12012a.95727.95727,0,0,0,.41309.228,15.4171,15.4171,0,0,1,11.63379,4.8496c3.876,4.20557,5.70117,11.002,5.1416,19.13721l-.01758.2544-.2168.13525a85.4635,85.4635,0,0,1-9.11816,5.02734c-10.97852,5.16211-21.001,6.11866-30.63379,2.92041l-.17676-.05859-4.043-6.77588c-.83007,4.67334-.38671,20.17465-5.14941,21.01449l-8.29883-10.96517Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#2f2e41"
    />
    <path
      d="M417.994,263.30087c8.51008-4.39247-2.43482-20.33442-.23553-29.65523,2.19936-9.32082,18.037-12.31871,19.04593-21.84222s3.38245-19.346,9.6668-26.5725c4.01568-4.61773,9.93278-8.02669,16.02491-7.44829a14.40869,14.40869,0,0,1,12.62827,17.79208c1.73454-2.45776,6.22341-1.92509,7.33449.87052.98788,2.48528-1.19437,5.49567-3.76252,5.71556-3.36046,4.15-7.2086,8.55427-12.47325,9.39143a5.6806,5.6806,0,0,1-4.84076-1.11733c-1.23856-1.18942-1.33489-3.56739.13434-4.45625-6.61615,2.62814-10.49509,9.78155-11.47678,16.83259-.98162,7.051.3765,14.18523,1.27147,21.24777s1.28058,14.492-1.48859,21.05046c-3.27178,7.74885-10.80453,13.30263-19.02519,15.0837s-16.97551.04034-24.41659-3.88148c-7.44108-3.92212-13.64622-9.90941-18.71523-16.62188C396.39747,265.89,408.47784,268.21276,417.994,263.30087Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#2f2e41"
    />
    <path
      d="M485.35053,233.24577c-8.74377,15.063,7.72065,40.4432-8.87275,45.71354l1.367-1.367c10.0162-12.32036-10.919-38.397-.90274-50.71737a30.10219,30.10219,0,0,0,3.97967-5.91559"
      transform="translate(-241.16498 -177.71861)"
      fill="#2f2e41"
    />
    <path
      d="M471.80491,241.29893s7.408-27.65168,39.16341-34.03389c.03575-.01179.15508-.05956.31017-.13106.09538-.0597.21471-.1194.334-.179-.35786-.20285-.70378-.38167-1.06172-.56078a.01167.01167,0,0,1-.01186-.01194c-.31017-.28629-.62034-.57258-.94245-.84693l-.90663.03583S476.82711,200.52519,471.80491,241.29893Z"
      transform="translate(-241.16498 -177.71861)"
      fill="#fd6584"
    />
  </svg>
);

export const MyApp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    width="680.83858"
    height="584.23207"
    viewBox="0 0 680.83858 584.23207"
  >
    <path
      id="b9ccae5a-ffdd-4f5c-9c1e-05af9f0f3372-939"
      data-name="Path 438"
      d="M310.70569,694.02818a24.21459,24.21459,0,0,0,23.38269-4.11877c8.18977-6.87441,10.758-18.196,12.8467-28.68191l6.17973-31.01657-12.9377,8.90837c-9.30465,6.40641-18.81826,13.01866-25.26011,22.29785s-9.25223,21.94707-4.07792,31.988"
      transform="translate(-259.58071 -157.88396)"
      fill="#e6e6e6"
    />
    <path
      id="f4ad1d06-bd03-4ced-a5c4-c19a65ab4ee5-940"
      data-name="Path 439"
      d="M312.7034,733.73874c-1.62839-11.86368-3.30382-23.88078-2.15884-35.87167,1.01467-10.64932,4.26373-21.04881,10.87831-29.57938a49.20592,49.20592,0,0,1,12.62466-11.44039c1.26215-.79648,2.42409,1.20354,1.16733,1.997a46.77949,46.77949,0,0,0-18.50446,22.32562c-4.02857,10.24607-4.67545,21.41582-3.98154,32.3003.41944,6.58218,1.31074,13.1212,2.20588,19.65251a1.19817,1.19817,0,0,1-.808,1.42251,1.16348,1.16348,0,0,1-1.42253-.808Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#f2f2f2"
    />
    <path
      id="baf785f8-b4c6-42cf-85bd-8a16037845f7-941"
      data-name="Path 442"
      d="M324.42443,714.70229a17.82513,17.82513,0,0,0,15.53141,8.01862c7.8644-.37318,14.41806-5.85973,20.31713-11.07027l17.452-15.4088-11.54987-.55281c-8.30619-.39784-16.82672-.771-24.73813,1.79338s-15.20758,8.72639-16.654,16.91541"
      transform="translate(-259.58071 -157.88396)"
      fill="#e6e6e6"
    />
    <path
      id="a14e4330-7125-4e03-a856-d6453c34f6cc-942"
      data-name="Path 443"
      d="M308.10042,740.55843c7.83972-13.87142,16.93234-29.28794,33.1808-34.21552a37.02609,37.02609,0,0,1,13.95545-1.441c1.48189.128,1.11179,2.41174-.367,2.28454a34.39833,34.39833,0,0,0-22.27164,5.89215c-6.27994,4.27453-11.16975,10.21755-15.30781,16.51907-2.53511,3.86051-4.80576,7.88445-7.07642,11.903C309.48824,742.78513,307.36641,741.85759,308.10042,740.55843Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#f2f2f2"
    />
    <path
      id="ac20a106-7eb8-4a45-8835-674ef3bf3222-943"
      data-name="Path 141"
      d="M935.3957,569.31654H503.18092a5.03014,5.03014,0,0,1-5.02359-5.02359V162.90754a5.03017,5.03017,0,0,1,5.02359-5.02358H935.3957a5.03017,5.03017,0,0,1,5.02359,5.02358V564.292a5.02922,5.02922,0,0,1-5.02359,5.02359Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#fff"
    />
    <path
      id="a8878079-c7cd-406f-a434-8b15b914b9b4-944"
      data-name="Path 141"
      d="M935.3957,569.31654H503.18092a5.03014,5.03014,0,0,1-5.02359-5.02359V162.90754a5.03017,5.03017,0,0,1,5.02359-5.02358H935.3957a5.03017,5.03017,0,0,1,5.02359,5.02358V564.292a5.02922,5.02922,0,0,1-5.02359,5.02359ZM503.18092,159.88944a3.01808,3.01808,0,0,0-3.01152,3.01151V564.292a3.01808,3.01808,0,0,0,3.01152,3.01152H935.3957a3.01717,3.01717,0,0,0,3.01153-3.01152V162.90754a3.01809,3.01809,0,0,0-3.01153-3.01151Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#cacaca"
    />
    <path
      id="af64f961-e9a2-4c53-a333-5060c7f850d2-945"
      data-name="Path 142"
      d="M707.41023,262.18528a3.41053,3.41053,0,0,0,0,6.82105H894.55305a3.41053,3.41053,0,0,0,0-6.82105Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#e4e4e4"
    />
    <path
      id="baad4cfb-158d-4439-9cc3-22475bf47b22-946"
      data-name="Path 143"
      d="M707.41023,282.65037a3.41054,3.41054,0,0,0,0,6.82106h95.54019a3.41054,3.41054,0,0,0,0-6.82106Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#e4e4e4"
    />
    <path
      id="f3456279-91e5-49ad-aa43-9838b26fb6ca-947"
      data-name="Path 142"
      d="M543.84146,392.7046a3.41054,3.41054,0,0,0,0,6.82106h350.8937a3.41054,3.41054,0,0,0,0-6.82106Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#e4e4e4"
    />
    <path
      id="a3288adf-49f8-485f-8ae9-1e4f1a13d849-948"
      data-name="Path 143"
      d="M543.84146,413.1697a3.41054,3.41054,0,0,0,0,6.82106H803.13254a3.41054,3.41054,0,0,0,0-6.82106Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#e4e4e4"
    />
    <path
      id="e63a5b48-5a7d-40a2-b9b0-6adec326348a-949"
      data-name="Path 142"
      d="M543.84146,433.17177a3.41054,3.41054,0,0,0,0,6.82106h350.8937a3.41054,3.41054,0,0,0,0-6.82106Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#e4e4e4"
    />
    <path
      id="a1c669b4-dfc3-4cfa-a7be-66b71399844d-950"
      data-name="Path 143"
      d="M543.84146,453.63687a3.41054,3.41054,0,0,0,0,6.82106H803.13254a3.41054,3.41054,0,0,0,0-6.82106Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#e4e4e4"
    />
    <path
      id="bfec50d1-ffb1-4de6-a9ef-a1085e40e016-951"
      data-name="Path 142"
      d="M543.84146,474.17177a3.41054,3.41054,0,0,0,0,6.82106h350.8937a3.41054,3.41054,0,0,0,0-6.82106Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#e4e4e4"
    />
    <path
      id="bc9696ec-ec99-41d5-9116-3ad9737a38ac-952"
      data-name="Path 143"
      d="M543.84146,494.63687a3.41054,3.41054,0,0,0,0,6.82106H803.13254a3.41054,3.41054,0,0,0,0-6.82106Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#e4e4e4"
    />
    <path
      d="M599.41943,324.82812a49,49,0,1,1,48.99952-49A49.05567,49.05567,0,0,1,599.41943,324.82812Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#0879f9"
    />
    <path
      d="M450.67833,510.10041a12.24754,12.24754,0,0,0-14.953-11.36231l-16.19641-22.82521-16.27138,6.45945,23.32519,31.91237a12.31392,12.31392,0,0,0,24.09559-4.1843Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#a0616a"
    />
    <path
      d="M419.11211,508.40888l-49.00774-63.57777L388.46714,387.12c1.34563-14.50936,10.425-18.56089,10.81135-18.72645l.5893-.25281,15.979,42.6119-11.73235,31.28625,28.79671,48.4319Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#3f3d56"
    />
    <path
      d="M589.30794,312.41993a12.24758,12.24758,0,0,0-10.17219,15.78672l-21.50463,17.91269,7.69816,15.72326,30.01343-25.72272a12.31392,12.31392,0,0,0-6.03477-23.69995Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#a0616a"
    />
    <path
      d="M590.06206,344.02244l-59.59835,53.77665-58.95815-13.84578c-14.57-.21979-19.31136-8.9587-19.50629-9.33113l-.29761-.568,41.2489-19.22578,32.0997,9.27828,46.06046-32.45509Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#3f3d56"
    />
    <polygon
      points="227.248 568.437 243.261 568.436 250.878 506.672 227.245 506.673 227.248 568.437"
      fill="#a0616a"
    />
    <path
      d="M483.39733,721.74476h50.32614a0,0,0,0,1,0,0V741.189a0,0,0,0,1,0,0h-36.207a14.11914,14.11914,0,0,1-14.11914-14.11914v-5.32505A0,0,0,0,1,483.39733,721.74476Z"
      transform="translate(757.57348 1305.02654) rotate(179.99738)"
      fill="#2f2e41"
    />
    <polygon
      points="163.247 568.437 179.26 568.436 186.878 506.672 163.245 506.673 163.247 568.437"
      fill="#a0616a"
    />
    <path
      d="M419.397,721.74476H469.7231a0,0,0,0,1,0,0V741.189a0,0,0,0,1,0,0h-36.207A14.11914,14.11914,0,0,1,419.397,727.06981v-5.32505a0,0,0,0,1,0,0Z"
      transform="translate(629.57273 1305.02946) rotate(179.99738)"
      fill="#2f2e41"
    />
    <polygon
      points="157.552 342.991 158.858 434.42 160.165 554.584 188.899 551.972 203.267 386.094 221.553 551.972 251.218 551.972 254.206 384.788 243.757 348.216 157.552 342.991"
      fill="#2f2e41"
    />
    <path
      d="M473.37417,513.1531c-31.26533.00239-60.04471-14.14839-60.43319-14.34263l-.32273-.16136-2.62373-62.96637c-.76082-2.22509-15.74263-46.13091-18.28-60.08625-2.57083-14.13882,34.68842-26.54742,39.213-27.99853l1.02678-11.37405,41.75366-4.49918,5.292,14.5536,14.97942,5.6168a7.40924,7.40924,0,0,1,4.59212,8.7043l-8.32539,33.85619,20.33325,112.01266-4.37755.18946C495.709,511.39658,484.38425,513.1525,473.37417,513.1531Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#3f3d56"
    />
    <circle
      cx="454.46738"
      cy="294.45965"
      r="30.06284"
      transform="matrix(0.87745, -0.47966, 0.47966, 0.87745, -345.12824, 96.19037)"
      fill="#a0616a"
    />
    <path
      d="M430.1166,323.56132c5.72926,6.10289,16.36927,2.82672,17.1158-5.51069a10.07153,10.07153,0,0,0-.01268-1.94523c-.38544-3.69311-2.519-7.046-2.008-10.94542a5.73974,5.73974,0,0,1,1.05046-2.687c4.56548-6.11359,15.28263,2.73444,19.59138-2.8,2.642-3.39359-.46364-8.73664,1.56381-12.52956,2.67591-5.006,10.60183-2.53654,15.57222-5.27809,5.53017-3.05032,5.1994-11.53517,1.55907-16.6961-4.43955-6.294-12.22348-9.65241-19.91044-10.13643s-15.32094,1.59394-22.4974,4.39069c-8.15392,3.17767-16.23969,7.56925-21.25749,14.739-6.10218,8.71919-6.68942,20.44132-3.6376,30.63677C419.10222,311.0013,425.43805,318.57766,430.1166,323.56132Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#2f2e41"
    />
    <path
      d="M596.58984,294.33545a3.488,3.488,0,0,1-2.38134-.93555l-16.15723-15.00732a3.49994,3.49994,0,0,1,4.76367-5.12891l13.68555,12.71192,27.07666-27.07618a3.5,3.5,0,1,1,4.94922,4.9502l-29.46094,29.46094A3.49275,3.49275,0,0,1,596.58984,294.33545Z"
      transform="translate(-259.58071 -157.88396)"
      fill="#fff"
    />
  </svg>
);

export const Register = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.6667 9.33317H20.0001V5.33317C20.0001 3.8665 18.8001 2.6665 17.3334 2.6665H14.6667C13.2001 2.6665 12.0001 3.8665 12.0001 5.33317V9.33317H5.33341C3.86675 9.33317 2.66675 10.5332 2.66675 11.9998V26.6665C2.66675 28.1332 3.86675 29.3332 5.33341 29.3332H26.6667C28.1334 29.3332 29.3334 28.1332 29.3334 26.6665V11.9998C29.3334 10.5332 28.1334 9.33317 26.6667 9.33317ZM12.0001 15.9998C13.1067 15.9998 14.0001 16.8932 14.0001 17.9998C14.0001 19.1065 13.1067 19.9998 12.0001 19.9998C10.8934 19.9998 10.0001 19.1065 10.0001 17.9998C10.0001 16.8932 10.8934 15.9998 12.0001 15.9998ZM16.0001 23.9998H8.00008V23.4265C8.00008 22.6265 8.48008 21.8932 9.22675 21.5732C10.0801 21.1998 11.0134 20.9998 12.0001 20.9998C12.9867 20.9998 13.9201 21.1998 14.7734 21.5732C15.5067 21.8932 16.0001 22.6132 16.0001 23.4265V23.9998ZM17.3334 11.9998H14.6667V5.33317H17.3334V11.9998ZM23.0001 21.9998H19.6667C19.1201 21.9998 18.6667 21.5465 18.6667 20.9998C18.6667 20.4532 19.1201 19.9998 19.6667 19.9998H23.0001C23.5467 19.9998 24.0001 20.4532 24.0001 20.9998C24.0001 21.5465 23.5467 21.9998 23.0001 21.9998ZM23.0001 17.9998H19.6667C19.1201 17.9998 18.6667 17.5465 18.6667 16.9998C18.6667 16.4532 19.1201 15.9998 19.6667 15.9998H23.0001C23.5467 15.9998 24.0001 16.4532 24.0001 16.9998C24.0001 17.5465 23.5467 17.9998 23.0001 17.9998Z"
      fill="#377DFF"
    />
  </svg>
);

export const Apply = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.6666 2.6665H5.33325V29.3332H26.6666V10.6665L18.6666 2.6665ZM17.3333 19.9998V25.3332H14.6666V19.9998H10.6666L16.0133 14.6665L21.3333 19.9998H17.3333ZM17.3333 11.9998V4.6665L24.6666 11.9998H17.3333Z"
      fill="#377DFF"
    />
  </svg>
);

export const Result = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.8799 9.87984L19.4399 3.43984C18.9466 2.9465 18.2666 2.6665 17.5599 2.6665H7.99992C6.53325 2.6665 5.33325 3.8665 5.33325 5.33317V26.6665C5.33325 28.1332 6.53325 29.3332 7.99992 29.3332H23.9999C25.4666 29.3332 26.6666 28.1332 26.6666 26.6665V11.7732C26.6666 11.0665 26.3866 10.3865 25.8799 9.87984ZM20.9866 24.9865C20.4666 25.5065 19.6266 25.5065 19.1066 24.9865L17.5333 23.4132C15.7599 24.3598 13.5199 24.1198 12.0266 22.6265C9.99992 20.5998 10.2266 17.1865 12.6933 15.4665C14.2399 14.3865 16.3999 14.3865 17.9599 15.4665C20.0266 16.9065 20.4933 19.5198 19.4133 21.5332L20.9866 23.1065C21.5066 23.6265 21.5066 24.4665 20.9866 24.9865ZM18.6666 11.9998C17.9333 11.9998 17.3333 11.3998 17.3333 10.6665V4.6665L24.6666 11.9998H18.6666Z"
      fill="#377DFF"
    />
    <path
      d="M15.3333 21.3332C16.4378 21.3332 17.3333 20.4377 17.3333 19.3332C17.3333 18.2286 16.4378 17.3332 15.3333 17.3332C14.2287 17.3332 13.3333 18.2286 13.3333 19.3332C13.3333 20.4377 14.2287 21.3332 15.3333 21.3332Z"
      fill="#377DFF"
    />
  </svg>
);

export const Accepted = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.6666 16L27.4132 12.28L27.8666 7.36L23.0533 6.26667L20.5333 2L15.9999 3.94667L11.4666 2L8.94658 6.25333L4.13325 7.33333L4.58659 12.2667L1.33325 16L4.58659 19.72L4.13325 24.6533L8.94658 25.7467L11.4666 30L15.9999 28.04L20.5333 29.9867L23.0533 25.7333L27.8666 24.64L27.4132 19.72L30.6666 16ZM12.5066 21.3467L9.33325 18.1467C8.81325 17.6267 8.81325 16.7867 9.33325 16.2667L9.42659 16.1733C9.94658 15.6533 10.7999 15.6533 11.3199 16.1733L13.4666 18.3333L20.3333 11.4533C20.8533 10.9333 21.7066 10.9333 22.2266 11.4533L22.3199 11.5467C22.8399 12.0667 22.8399 12.9067 22.3199 13.4267L14.4266 21.3467C13.8799 21.8667 13.0399 21.8667 12.5066 21.3467Z"
      fill="#377DFF"
    />
  </svg>
);

export const BackSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.2536 16.0886C15.6227 16.4224 15.652 16.993 15.3191 17.3631C14.9862 17.7332 14.4171 17.7625 14.048 17.4287L8.74591 12.6335C8.34874 12.2743 8.34983 11.6491 8.74826 11.2913L14.0041 6.57128C14.3743 6.23878 14.9433 6.27016 15.2749 6.64138C15.6066 7.0126 15.5753 7.58309 15.205 7.9156L11.0253 11.6693C10.8609 11.8169 10.8473 12.0698 10.995 12.2341C11.0042 12.2444 11.014 12.2543 11.0242 12.2635L15.2536 16.0886Z"
      fill="black"
    />
  </svg>
);

export const EmtpyRoundSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_728_8451)">
      <path
        d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20Z"
        fill="#D9D9D9"
      />
    </g>
    <defs>
      <clipPath id="clip0_728_8451">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const FullRoundSvg = ({ color = "#1C84FF" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_728_8458)">
      <path
        d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20Z"
        fill={color}
      />
      <circle cx="12" cy="12" r="5" fill={color} />
    </g>
    <defs>
      <clipPath id="clip0_728_8458">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BurgerSvg = ({ ...rest }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M4 18H20M4 6H20H4ZM4 12H20H4Z"
      stroke="#111E52"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CloseSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.56066 0.43934C1.97487 -0.146447 1.02513 -0.146447 0.43934 0.43934C-0.146447 1.02513 -0.146447 1.97487 0.43934 2.56066L7.87868 10L0.439341 17.4393C-0.146445 18.0251 -0.146445 18.9749 0.439341 19.5607C1.02513 20.1464 1.97487 20.1464 2.56066 19.5607L10 12.1213L17.4393 19.5607C18.0251 20.1464 18.9749 20.1464 19.5607 19.5607C20.1464 18.9749 20.1464 18.0251 19.5607 17.4393L12.1213 10L19.5607 2.56066C20.1464 1.97487 20.1464 1.02513 19.5607 0.43934C18.9749 -0.146447 18.0251 -0.146447 17.4393 0.43934L10 7.87868L2.56066 0.43934Z"
      fill="#252a31"
    />
  </svg>
);

export const UploadSvg = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="4" fill="#004FFF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3781 6.36045L8.12664 16.6119L7.59631 16.0815C8.12664 16.6119 8.12729 16.6112 8.1275 16.611L8.12142 16.6172C8.11552 16.6233 8.10562 16.6336 8.09212 16.648C8.06508 16.6767 8.02371 16.7217 7.97117 16.7816C7.86595 16.9017 7.71692 17.0809 7.54925 17.3095C7.21165 17.7699 6.81025 18.4148 6.5323 19.1692C6.25491 19.9222 6.10848 20.7615 6.24856 21.63C6.38712 22.4891 6.81438 23.4313 7.77308 24.39C8.73179 25.3487 9.67403 25.776 10.5331 25.9146C11.4016 26.0547 12.241 25.9082 12.9939 25.6308C13.7483 25.3529 14.3933 24.9515 14.8536 24.6139C15.0823 24.4462 15.2614 24.2972 15.3815 24.192C15.4415 24.1394 15.4864 24.098 15.5152 24.071C15.5295 24.0575 15.5398 24.0476 15.5459 24.0417L15.5517 24.0361L25.4508 14.137C25.7436 13.8441 26.2185 13.8441 26.5114 14.137C26.8043 14.4299 26.8043 14.9048 26.5114 15.1977L16.6119 25.0972L16.0816 24.5668C16.6119 25.0972 16.6122 25.0969 16.6119 25.0972L16.6091 25.0999L16.6047 25.1043L16.5907 25.118C16.5791 25.1293 16.563 25.1447 16.5427 25.1638C16.5021 25.202 16.4441 25.2552 16.3701 25.3201C16.2223 25.4497 16.0092 25.6266 15.7407 25.8235C15.2067 26.2151 14.4374 26.6976 13.5124 27.0383C12.586 27.3797 11.4808 27.5868 10.2943 27.3954C9.09831 27.2025 7.87504 26.6133 6.71242 25.4507C5.54981 24.2881 4.9606 23.0648 4.7677 21.8689C4.57633 20.6824 4.78345 19.5772 5.12478 18.6507C5.46555 17.7257 5.94803 16.9565 6.33964 16.4225C6.53657 16.1539 6.71348 15.9409 6.84303 15.793C6.90789 15.719 6.96111 15.6611 6.99934 15.6204C7.01846 15.6001 7.03385 15.5841 7.04509 15.5725L7.05879 15.5585L7.06322 15.554L7.06481 15.5524C7.06508 15.5521 7.06598 15.5512 7.59631 16.0815L7.06598 15.5512L17.319 5.29816L17.8494 5.82849C17.319 5.29816 17.3187 5.29844 17.319 5.29816L17.3202 5.29699L17.3216 5.29556L17.3253 5.29193L17.3358 5.28165C17.3443 5.27349 17.3555 5.26276 17.3694 5.24971C17.3973 5.22364 17.4361 5.18825 17.4852 5.14571C17.5832 5.06081 17.7232 4.94645 17.8996 4.82044C18.2494 4.57053 18.7584 4.26351 19.38 4.05631C20.0047 3.84808 20.7579 3.73616 21.5762 3.89981C22.3999 4.06457 23.2366 4.49825 24.0365 5.29816C24.8364 6.09807 25.2701 6.93475 25.4349 7.75853C25.5985 8.57677 25.4866 9.33005 25.2784 9.95475C25.0712 10.5763 24.7642 11.0853 24.5143 11.4351C24.3883 11.6115 24.2739 11.7515 24.189 11.8495C24.1464 11.8986 24.1111 11.9374 24.085 11.9653C24.0719 11.9792 24.0612 11.9904 24.0531 11.9989L24.0428 12.0094L24.0391 12.0131L24.0377 12.0145C24.0374 12.0148 24.0365 12.0157 23.5062 11.4853L24.0365 12.0157L14.137 21.9152L13.6067 21.3848C14.137 21.9152 14.1373 21.9149 14.137 21.9152L14.1347 21.9175L14.1318 21.9204L14.1243 21.9277L14.1029 21.9481C14.0857 21.9641 14.0627 21.985 14.0344 22.0096C13.9778 22.0586 13.8986 22.1233 13.7996 22.194C13.6044 22.3334 13.3164 22.5079 12.96 22.6267C12.6005 22.7465 12.1565 22.8143 11.6698 22.7169C11.1774 22.6184 10.6943 22.3615 10.248 21.9152C9.80161 21.4688 9.54469 20.9857 9.44623 20.4934C9.34887 20.0066 9.4166 19.5627 9.53645 19.2031C9.65525 18.8467 9.82968 18.5588 9.96911 18.3636C10.0399 18.2645 10.1045 18.1853 10.1535 18.1287C10.1781 18.1004 10.199 18.0774 10.215 18.0603L10.2355 18.0388L10.2427 18.0313L10.2456 18.0284L10.2469 18.0272C10.2471 18.0269 10.248 18.0261 10.7783 18.5564L10.248 18.0261L19.4403 8.83369C19.7332 8.5408 20.2081 8.5408 20.501 8.83369C20.7939 9.12659 20.7939 9.60146 20.501 9.89435L11.3121 19.0833C11.3116 19.0837 11.3111 19.0843 11.3105 19.085C11.3065 19.0892 11.2984 19.0981 11.287 19.1111C11.2642 19.1375 11.2294 19.1798 11.1897 19.2354C11.1082 19.3496 11.0174 19.5036 10.9595 19.6775C10.9025 19.8483 10.8819 20.0231 10.9171 20.1992C10.9512 20.3698 11.0479 20.5938 11.3086 20.8545C11.5694 21.1153 11.7933 21.2119 11.9639 21.246C12.1401 21.2813 12.3149 21.2606 12.4857 21.2037C12.6596 21.1457 12.8136 21.055 12.9277 20.9734C12.9833 20.9337 13.0257 20.8989 13.052 20.8761C13.0651 20.8648 13.0739 20.8566 13.0781 20.8527L13.0774 20.8535L13.0798 20.8511C13.0806 20.8504 13.081 20.85 13.081 20.85L13.0798 20.8511L22.9742 10.9566C22.9742 10.9567 22.9739 10.957 22.9742 10.9566L22.975 10.9559L22.9896 10.9405C23.0036 10.9256 23.0262 10.9009 23.0555 10.8671C23.1142 10.7993 23.1987 10.6962 23.2937 10.5633C23.4857 10.2944 23.709 9.91948 23.8554 9.48041C24.0007 9.04445 24.0655 8.56029 23.964 8.0527C23.8636 7.55065 23.5902 6.97313 22.9759 6.35882C22.3616 5.74451 21.784 5.47109 21.282 5.37068C20.7744 5.26917 20.2903 5.33402 19.8543 5.47934C19.4152 5.6257 19.0403 5.84902 18.7714 6.04104C18.6385 6.13601 18.5354 6.22052 18.4676 6.27925C18.4338 6.30853 18.4091 6.33114 18.3942 6.34512L18.3793 6.35928C18.3787 6.35978 18.3783 6.36017 18.3781 6.36045Z"
      fill="white"
    />
  </svg>
);

export const PdfSvg = () => (
  <svg
    width="24"
    height="28"
    viewBox="0 0 24 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.0588 28H1.94118C0.869095 28 0 27.1046 0 26V2C0 0.895431 0.869095 0 1.94118 0H15L24 9.27273V26C24 27.1046 23.1309 28 22.0588 28Z"
      fill="#FF7981"
    />
    <path
      d="M5.49043 19.7629C5.40214 19.7629 5.32779 19.7318 5.26738 19.6696C5.20696 19.6073 5.17676 19.5307 5.17676 19.4397V15.0445C5.17676 14.9535 5.20696 14.8769 5.26738 14.8147C5.32779 14.7476 5.40214 14.7141 5.49043 14.7141H7.07973C7.5212 14.7141 7.88135 14.7907 8.16017 14.9439C8.43899 15.0971 8.63882 15.2934 8.75964 15.5328C8.88046 15.7722 8.94088 16.0308 8.94088 16.3085C8.94088 16.5862 8.88046 16.8447 8.75964 17.0841C8.63882 17.3235 8.43899 17.5198 8.16017 17.673C7.88135 17.8262 7.5212 17.9028 7.07973 17.9028H5.81108V19.4397C5.81108 19.5307 5.77855 19.6073 5.71349 19.6696C5.65308 19.7318 5.57873 19.7629 5.49043 19.7629ZM7.01699 17.2852C7.49099 17.2852 7.82326 17.1918 8.01379 17.0051C8.20896 16.8184 8.30655 16.5862 8.30655 16.3085C8.30655 16.0308 8.20896 15.7986 8.01379 15.6118C7.82326 15.4251 7.49099 15.3317 7.01699 15.3317H5.81108V17.2852H7.01699Z"
      fill="white"
    />
    <path
      d="M10.6617 19.727C10.5734 19.727 10.4991 19.6959 10.4387 19.6337C10.3783 19.5714 10.3481 19.4948 10.3481 19.4038V15.0445C10.3481 14.9535 10.3783 14.8769 10.4387 14.8147C10.4991 14.7476 10.5734 14.7141 10.6617 14.7141H12.0628C12.5926 14.7141 13.041 14.8362 13.4082 15.0804C13.7799 15.3198 14.0587 15.631 14.2446 16.014C14.4305 16.3971 14.5234 16.7992 14.5234 17.2206C14.5234 17.6419 14.4305 18.0441 14.2446 18.4271C14.0587 18.8101 13.7799 19.1237 13.4082 19.3679C13.041 19.6073 12.5926 19.727 12.0628 19.727H10.6617ZM11.9862 19.1166C12.3672 19.1166 12.7018 19.0376 12.9899 18.8796C13.278 18.7168 13.5011 18.4941 13.6591 18.2117C13.8171 17.9244 13.8961 17.594 13.8961 17.2206C13.8961 16.8471 13.8171 16.5191 13.6591 16.2367C13.5011 15.9494 13.278 15.7267 12.9899 15.5687C12.7018 15.406 12.3672 15.3246 11.9862 15.3246H10.9824V19.1166H11.9862Z"
      fill="white"
    />
    <path
      d="M16.3844 19.7629C16.2961 19.7629 16.2218 19.7318 16.1614 19.6696C16.101 19.6073 16.0708 19.5307 16.0708 19.4397V15.0445C16.0708 14.9535 16.101 14.8769 16.1614 14.8147C16.2218 14.7476 16.2961 14.7141 16.3844 14.7141H19.096C19.1796 14.7141 19.2493 14.7452 19.3051 14.8075C19.3655 14.8649 19.3957 14.9367 19.3957 15.0229C19.3957 15.1091 19.3655 15.1809 19.3051 15.2384C19.2493 15.2958 19.1796 15.3246 19.096 15.3246H16.7051V16.9117H18.852C18.9357 16.9117 19.0054 16.9429 19.0611 17.0051C19.1215 17.0626 19.1518 17.1344 19.1518 17.2206C19.1518 17.3067 19.1215 17.3786 19.0611 17.436C19.0054 17.4935 18.9357 17.5222 18.852 17.5222H16.7051V19.4397C16.7051 19.5307 16.6725 19.6073 16.6075 19.6696C16.5471 19.7318 16.4727 19.7629 16.3844 19.7629Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.89313 16.8726L7.89391 16.8718C8.05264 16.7199 8.13028 16.5362 8.13028 16.3084C8.13028 16.0806 8.05264 15.8969 7.89391 15.745L7.89313 15.7443L7.89236 15.7435C7.75253 15.6065 7.47884 15.5135 7.01719 15.5135H5.98775V17.1033H7.01719C7.47884 17.1033 7.75253 17.0103 7.89236 16.8733L7.89313 16.8726ZM5.81128 17.2851V15.3317H7.01719C7.49119 15.3317 7.82346 15.425 8.01399 15.6118C8.20916 15.7985 8.30675 16.0307 8.30675 16.3084C8.30675 16.5861 8.20916 16.8183 8.01399 17.005C7.82346 17.1918 7.49119 17.2851 7.01719 17.2851H5.81128ZM13.5032 19.5212L13.5027 19.5215C13.1017 19.783 12.6188 19.9088 12.063 19.9088H10.6619C10.5286 19.9088 10.4088 19.8597 10.3141 19.7622C10.2194 19.6646 10.1718 19.5412 10.1718 19.4038V15.0444C10.1718 14.9081 10.2186 14.7856 10.3118 14.6884C10.4051 14.5862 10.5254 14.5322 10.6619 14.5322H12.063C12.619 14.5322 13.102 14.6605 13.503 14.9268C13.9002 15.1829 14.2016 15.5184 14.4027 15.9326C14.6006 16.3405 14.7001 16.7705 14.7001 17.2205C14.7001 17.6705 14.6006 18.1005 14.4027 18.5084C14.2016 18.9226 13.9002 19.2604 13.5032 19.5212ZM13.4084 15.0803C13.0412 14.8361 12.5928 14.714 12.063 14.714H10.6619C10.5736 14.714 10.4993 14.7476 10.4389 14.8146C10.3785 14.8768 10.3483 14.9534 10.3483 15.0444V19.4038C10.3483 19.4947 10.3785 19.5713 10.4389 19.6336C10.4993 19.6958 10.5736 19.727 10.6619 19.727H12.063C12.5928 19.727 13.0412 19.6073 13.4084 19.3679C13.7801 19.1237 14.0589 18.8101 14.2448 18.427C14.4307 18.044 14.5236 17.6418 14.5236 17.2205C14.5236 16.7992 14.4307 16.397 14.2448 16.014C14.0589 15.6309 13.7801 15.3197 13.4084 15.0803ZM13.5061 16.3268L13.5058 16.3262C13.3646 16.0696 13.1663 15.8713 12.9072 15.7292L12.9062 15.7286L12.9053 15.7281C12.647 15.5822 12.3425 15.5063 11.9864 15.5063H11.1591V18.9347H11.9864C12.3429 18.9347 12.6478 18.861 12.9062 18.7195C13.1665 18.5723 13.365 18.3733 13.5061 18.1214C13.6469 17.865 13.7198 17.5665 13.7198 17.2205C13.7198 16.8742 13.6468 16.5784 13.5064 16.3274L13.5061 16.3268ZM13.6593 18.2116C13.5013 18.4941 13.2782 18.7167 12.9901 18.8795C12.702 19.0375 12.3674 19.1165 11.9864 19.1165H10.9826V15.3245H11.9864C12.3674 15.3245 12.702 15.4059 12.9901 15.5687C13.2782 15.7267 13.5013 15.9493 13.6593 16.2366C13.8173 16.5191 13.8963 16.847 13.8963 17.2205C13.8963 17.594 13.8173 17.9243 13.6593 18.2116ZM5.49064 19.9447C5.35729 19.9447 5.23752 19.8957 5.14279 19.7981C5.04807 19.7005 5.00049 19.5771 5.00049 19.4397V15.0444C5.00049 14.9081 5.0473 14.7856 5.14048 14.6884C5.23377 14.5862 5.35405 14.5322 5.49064 14.5322H7.07993C7.5395 14.5322 7.93091 14.6117 8.24342 14.7834C8.54708 14.9503 8.776 15.1707 8.91641 15.4489C9.0507 15.715 9.11755 16.0024 9.11755 16.3084C9.11755 16.6144 9.0507 16.9019 8.91641 17.1679C8.776 17.4461 8.54708 17.6665 8.24342 17.8334C7.93091 18.0051 7.5395 18.0846 7.07993 18.0846H5.98775V19.4397C5.98775 19.5804 5.9354 19.7043 5.83616 19.8004C5.7418 19.8965 5.62289 19.9447 5.49064 19.9447ZM5.71369 19.6695C5.65328 19.7317 5.57893 19.7629 5.49064 19.7629C5.40234 19.7629 5.32799 19.7317 5.26758 19.6695C5.20716 19.6073 5.17696 19.5307 5.17696 19.4397V15.0444C5.17696 14.9534 5.20716 14.8768 5.26758 14.8146C5.32799 14.7476 5.40234 14.714 5.49064 14.714H7.07993C7.5214 14.714 7.88155 14.7907 8.16037 14.9439C8.43919 15.0971 8.63902 15.2934 8.75984 15.5328C8.88066 15.7722 8.94108 16.0307 8.94108 16.3084C8.94108 16.5861 8.88066 16.8447 8.75984 17.084C8.63902 17.3234 8.43919 17.5197 8.16037 17.673C7.88155 17.8262 7.5214 17.9028 7.07993 17.9028H5.81128V19.4397C5.81128 19.5307 5.77875 19.6073 5.71369 19.6695ZM16.3846 19.9447C16.2513 19.9447 16.1315 19.8957 16.0368 19.7981C15.9421 19.7005 15.8945 19.5771 15.8945 19.4397V15.0444C15.8945 14.9081 15.9413 14.7856 16.0345 14.6884C16.1278 14.5862 16.248 14.5322 16.3846 14.5322H19.0962C19.2258 14.5322 19.341 14.582 19.4302 14.6788C19.5241 14.7707 19.5724 14.8894 19.5724 15.0229C19.5724 15.1576 19.5232 15.2772 19.4276 15.3694C19.3369 15.4615 19.2223 15.5063 19.0962 15.5063H16.8817V16.7299H18.8522C18.9818 16.7299 19.097 16.7796 19.1862 16.8764C19.2801 16.9683 19.3284 17.087 19.3284 17.2205C19.3284 17.3552 19.2792 17.4749 19.1836 17.5671C19.093 17.6591 18.9783 17.704 18.8522 17.704H16.8817V19.4397C16.8817 19.5804 16.8294 19.7043 16.7302 19.8004C16.6358 19.8965 16.5169 19.9447 16.3846 19.9447ZM16.6077 19.6695C16.6727 19.6073 16.7053 19.5307 16.7053 19.4397V17.5221H18.8522C18.9359 17.5221 19.0056 17.4934 19.0613 17.436C19.1217 17.3785 19.152 17.3067 19.152 17.2205C19.152 17.1343 19.1217 17.0625 19.0613 17.005C19.0056 16.9428 18.9359 16.9117 18.8522 16.9117H16.7053V15.3245H19.0962C19.1798 15.3245 19.2495 15.2958 19.3053 15.2383C19.3657 15.1809 19.3959 15.109 19.3959 15.0229C19.3959 14.9367 19.3657 14.8649 19.3053 14.8074C19.2495 14.7452 19.1798 14.714 19.0962 14.714H16.3846C16.2963 14.714 16.222 14.7476 16.1616 14.8146C16.1012 14.8768 16.071 14.9534 16.071 15.0444V19.4397C16.071 19.5307 16.1012 19.6073 16.1616 19.6695C16.222 19.7317 16.2963 19.7629 16.3846 19.7629C16.4729 19.7629 16.5473 19.7317 16.6077 19.6695Z"
      fill="white"
    />
    <g opacity="0.7" filter="url(#filter0_d_146448_499)">
      <path
        d="M24 9.27273H16.9412C15.8691 9.27273 15 8.3773 15 7.27273V0L24 9.27273Z"
        fill="#D03954"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_146448_499"
        x="-8"
        y="-24"
        width="59"
        height="59.2727"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="1" />
        <feGaussianBlur stdDeviation="12.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_146448_499"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_146448_499"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
